window._i18n_ = {
  "date": {
    "formats": {
      "default": "%d-%m-%Y",
      "short": "%-d %B",
      "long": "%-d %B, %Y",
      "with_day": "%A, %-d %B",
      "without_day": "%-d %B %Y"
    },
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "number": {
    "format": {
      "separator": ".",
      "delimiter": ",",
      "precision": 3,
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "currency": {
      "format": {
        "format": "%u%n",
        "unit": "$",
        "separator": ".",
        "delimiter": ",",
        "precision": 2,
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "EUR": "€",
      "USD": "$",
      "CAD": "$"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    },
    "human": {
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "kb": "KB",
          "mb": "MB",
          "gb": "GB",
          "tb": "TB",
          "pb": "PB",
          "eb": "EB"
        }
      },
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "unit": "",
          "thousand": "Thousand",
          "million": "Million",
          "billion": "Billion",
          "trillion": "Trillion",
          "quadrillion": "Quadrillion"
        }
      }
    }
  },
  "datetime": {
    "distance_in_words": {
      "half_a_minute": "half a minute",
      "less_than_x_seconds": {
        "one": "less than 1 second",
        "other": "less than %{count} seconds"
      },
      "x_seconds": {
        "one": "1 second",
        "other": "%{count} seconds"
      },
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "about_x_hours": {
        "one": "about 1 hour",
        "other": "about %{count} hours"
      },
      "x_days": {
        "one": "1 day",
        "other": "%{count} days"
      },
      "about_x_months": {
        "one": "about 1 month",
        "other": "about %{count} months"
      },
      "x_months": {
        "one": "1 month",
        "other": "%{count} months"
      },
      "about_x_years": {
        "one": "about 1 year",
        "other": "about %{count} years"
      },
      "over_x_years": {
        "one": "over 1 year",
        "other": "over %{count} years"
      },
      "almost_x_years": {
        "one": "almost 1 year",
        "other": "almost %{count} years"
      },
      "x_years": {
        "one": "1 year",
        "other": "%{count} years"
      },
      "x_weeks": {
        "one": "1 week",
        "other": "%{count} weeks"
      },
      "x_hours": {
        "one": "1 hour",
        "other": "%{count} hours"
      }
    },
    "prompts": {
      "year": "Year",
      "month": "Month",
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "second": "Seconds"
    }
  },
  "page": {
    "transferReceived": {
      "subtitle": "Transfers sent to %{email}",
      "blocked-button": "Add an email",
      "blocked-description": "​​Add a receiving email to your page and all the transfers you’re sent will appear here.",
      "blocked-help": "Want to know more about how this works? Visit the <a href=\"https://wetransfer.zendesk.com/hc/en-us/articles/360030166132-New-Feature-Received-Transfers-Overview-RTO-\" rel=\"external\">help center</a>.",
      "blocked-title": "Keep track of transfers",
      "download": "Download",
      "downloaded": "Downloaded",
      "empty-description": "Here you’ll find all transfers sent to you — don’t worry, they won’t use up any of your storage",
      "empty-title": "Keep track of transfers",
      "title": "Received",
      "verify-button": "Send link",
      "verify-description": "You can see all of your received transfers here as soon you confirm that %{email} is really you. Hit the button below to send a verification link to your email.",
      "verify-title": "Keep track of transfers",
      "view": "View"
    },
    "advertise": {
      "contact": {
        "description_success_032019": "Thanks for getting in touch – we'll get back to you very soon.",
        "form": {
          "budget": "Budget indication in local currency",
          "telephone": "Telephone number",
          "button": "Get in touch",
          "company": "Company name",
          "country": "Country",
          "description": "Message",
          "email": "Email address",
          "first_name": "First name",
          "last_name": "Last name",
          "question": "Question"
        },
        "title_1905": "Get a quote",
        "description": "If you have questions regarding advertising on WeTransfer, please use this form to get in touch.",
        "description_success": "We are excited to support your campaigns with our unique premium advertising platform. We will get back to you within one working day.<br /><br />For some great examples of what’s possible on our platform, please see our <a href=\"http://we.tl/advertising_reel\" rel=\"external\">advertising show reel</a>.",
        "title": "Contact",
        "title_success": "Thank you for contacting WeTransfer"
      },
      "home": {
        "intro": {
          "description_032019": "The best way to build your brand in the creative community",
          "title_032019": "Advertise on WeTransfer",
          "description": "Advertising on WeTransfer is a unique opportunity to reach a huge global audience in a creative and compelling way. We present your brand’s message in a bigger, bolder and more beautiful way than any other online platform.",
          "title": "Advertise with us"
        },
        "stats": {
          "title": "It doesn't just look great – advertising on WeTransfer really works too.",
          "ctr": "Click Through Rate",
          "engagement": "Engagement Rate",
          "industry": "Industry standard: %{percentage} *",
          "our_number": "Our number: %{percentage} *",
          "our_time": "Our time: %{percentage} *",
          "source": "* Source: <a href=\"%{url}\" rel=\"external\">%{name}</a>",
          "view_time": "In view time"
        },
        "favourite": {
          "description": "We have an in-house creative studio to help you benefit from our native ad platform. Check out a selection of previous campaigns in our <a href=\"/advertise/gallery\">Advert Gallery</a>, see our <a href=\"http://we.tl/advertising_reel\" rel=\"external\">advertising show reel</a> or <a href=\"/advertise/contact\">contact us</a> to see how WeTransfer can work for you.",
          "title": "Some of our favorite campaigns"
        },
        "gallery": {
          "title": "Advert gallery"
        },
        "return_to": "Advertise",
        "team": "We have an in-house creative team who can help you make the most of our native ad platform. Check out some examples in our Advert Gallery or <a href=\"mailto:advertising@wetransfer.com\">contact us</a> to see how WeTransfer can work for you."
      },
      "nav": {
        "contact_1905": "Get a quote",
        "contact": "Contact",
        "download_dev_toolkit": "Developers toolkit",
        "download_mediakit": "Mediakit",
        "download_mockup": "Mockup template",
        "gallery": "Advert Gallery",
        "guidelines": "Advertising Guidelines",
        "home": "Advertise with us",
        "resources": "Resources"
      },
      "brands": "Leading brands that advertise on WeTransfer",
      "button": {
        "back": "Back to Advert Gallery",
        "contact": "Get a quote",
        "gallery": "Go to Advert Gallery",
        "guidelines": "Go to Advertising Guidelines"
      },
      "gallery": {
        "intro": {
          "description": "Browse through some campaigns we’ve built before and get inspired",
          "title": "Advert Gallery"
        },
        "preview": "Preview"
      },
      "guidelines": {
        "advert_animated": {
          "requirement_one": "Animation storyboard and assets",
          "short_description": "These wallpapers have elegant and enticing animations to engage users in a more dynamic way.",
          "title": "Animated wallpaper"
        },
        "advert_custom": {
          "requirement_one": "mp4 at minimum 1280 x 800 px (HD preferable)",
          "short_description": "These wallpapers are built specifically to fit your needs, where the templates above don’t quite cover them.",
          "title": "Custom wallpaper"
        },
        "advert_delivery_checklist_subtitle": "And also",
        "advert_delivery_checklist_title": "Delivery Checklist",
        "advert_general_requirements": {
          "requirement_eight": "In case you are building the wallpaper on your end, use the tools below to make sure it will work correctly on WeTransfer.",
          "requirement_five": "The URL you want the wallpaper to link to",
          "requirement_four": "All linked files and fonts",
          "requirement_one": "A creative brief and English translation of all copy",
          "requirement_seven": "Full and up to date list of our preferred 3rd party trackers",
          "requirement_six": "Any 3rd party trackers in https format",
          "requirement_three": "Any vector files are preferred for copy and logo's",
          "requirement_two": "2560 x 1600 px open Photoshop file in RGB"
        },
        "advert_interactive": {
          "requirement_one": "For video – mp4 at minimum 1280 x 800 px (HD preferable)",
          "short_description": "These wallpapers draw in users to engage, entertain and inform them, through responsive elements, interactive content and games.",
          "title": "Interactive wallpaper"
        },
        "advert_static": {
          "short_description": "A striking background image with a logo, header and a call-to-action",
          "title": "Static wallpaper"
        },
        "advert_video": {
          "requirement_one": "mp4 at minimum 1280 x 800 px (HD preferable)",
          "short_description": "These wallpapers all make use of video files, but range from seamless cinemagraphs or short intro videos, to a full video after user initiation.",
          "title": "Video wallpaper"
        },
        "important_info": {
          "point_five": "We reserve the right to decline advertisements which conflict with the WeTransfer style, aesthetics and values.  ",
          "point_four": "We provide regular reporting on daily delivery, impressions, clicks and video data. If you require advanced statistics or want to use external tracking please contact us.",
          "point_one": "Please deliver all (creative) assets a minimum of 5 working days prior to your campaign start date to <a href=\"mailto:traffic@wetransfer.com\">traffic@wetransfer.com</a>.",
          "point_three": "Adverts on WeTransfer are shown for 45 seconds before they rotate. That timer is paused when a user interacts with the wallpaper.",
          "title": "Useful information"
        },
        "intro": {
          "description": "This guide outlines what is possible and what is allowed on our platform. Our in-house creative studio is here to build great-looking, effective adverts with you to get the best out of our ad space. Please get in touch if you have any questions or need advice.",
          "title": "Advertising Guidelines"
        },
        "requirements": {
          "description": "So they look great and perform perfectly, all wallpapers are built in responsive HTML. We've outlined a few different types of wallpaper below – take a look and see what might work best for you.",
          "title": "The types of adverts we offer"
        },
        "should_be": {
          "point_one": {
            "description": "Your advert will be scaled and repositioned to fit the most common screensizes",
            "title": "Responsive"
          },
          "point_three": {
            "description": "Images speak louder than words - use only 1 logo and keep text under 140 characters",
            "title": "Focussed"
          },
          "point_two": {
            "description": "No sudden changes, flickering effects or intrusive visuals",
            "title": "Calm"
          },
          "title": "What your wallpaper needs to be"
        },
        "shouldnt_be": {
          "point_one": "We don’t allow ads that are sexual, political or religious in nature, or ads for tobacco, drugs or gambling",
          "point_three": "Wallpapers should not use/change the WeTransfer interface",
          "point_two": "Leave prices, discounts, disclaimers out of your wallpaper",
          "title": "What your wallpaper can’t be"
        },
        "tools": {
          "html5": {
            "button": "Download Mockup template",
            "text": "Create a HTML wallpaper and see how it will look on WeTransfer",
            "title": "Download Developer toolkit"
          },
          "resize": {
            "button": "Download",
            "text": "Check all important sizes, and the WeTransfer interface elements.",
            "title": "Mockup template"
          },
          "static": {
            "text": "A striking background image with a logo, header and a call-to-action",
            "title": "Static"
          },
          "title": "Tools"
        },
        "view_examples": "View examples"
      },
      "mobile_notice_text": "Our wallpapers are tailored for desktop. Please visit this URL on your desktop or have a look at our <a href=\"/advertise/gallery\">ad gallery</a>.",
      "mobile_notice_title": "Looking for advertisement?"
    },
    "plus": {
      "button": {
        "price": "for €10/month",
        "text": "Upgrade to Pro today"
      }
    },
    "profile": {
      "wallpapers": {
        "best_1": "Up to five different images",
        "best_2": "JPEG or PNG",
        "best_3": "Up to %{size}",
        "best_4": "%{resolution} pixels or more",
        "best_5": "No GIFs or videos (sorry)",
        "best_title": "The important bits:",
        "text": "Put yourself or your brand front and center with up to five rotating videos or images:",
        "best_five": "%{videoResolution} pixels for videos",
        "best_four": "%{resolution} pixels for images",
        "best_one": "Up to five videos or images",
        "best_six": "Image wallpapers rotate every %{rotationInterval} secs, videos longer than %{rotationInterval} secs will be cut short",
        "best_three": "%{size} max per video/image",
        "best_two": "JPEG, PNG or MP4",
        "notice": "Drumroll please — video wallpapers have landed! <a href='/profile'>Make your background a video now</a>."
      },
      "pagename": "Profile settings",
      "onboarding-step-one": "First things first, you need a web address.\n<strong>You can only set this once (no pressure).</strong>",
      "onboarding-step-two": "Present your files in style, personalize your WeTransfer profile and admire your new look at <a href='%{href}'>%{domain}</a>",
      "claim_now": "Set now",
      "profile_information": "Profile information",
      "profile_instruction": "Your web address is the direct link to your personal WeTransfer page. Your profile name can be anything, but keep in mind it will appear in the bottom right of the page.",
      "profile_wallpapers": "Choose your background",
      "email_background_instruction": "Make your transfer emails stand out by adding a background image.  \nFor best results please use an image of 1600 x 800 pixels (please note we’ll need to crop images wider than this). The maximum file size is 3MB.",
      "email_backgrounds": "Email backgrounds",
      "sent_you_files": "sent you some files",
      "disabled_tip": {
        "subtitle": "This is your profile page. You can set your background wallpapers here and personalize your emails.",
        "title": "Let’s show you around..."
      },
      "email_background_instruction_with_spec": "Make your transfer emails stand out by adding a background image.\nFor best results please use an image of %{resolution} pixels (please note we’ll need to crop images wider than this). The maximum file size is %{size}.",
      "received_transfers": {
        "hint": {
          "confirm_email": "Confirm your email with a quick link. %{send}",
          "not_yet_verified": "Check your inbox to confirm this address. %{resend}",
          "resend": "Send a new link?",
          "send": "Send link"
        }
      },
      "receiving": "Profile email",
      "receiving_checkbox": "Transfers sent through my page can only go to this email\n",
      "receiving_instruction": "Add an email to your Pro page so you can receive transfers of up to 20GB—and so people can see who they’re sending their transfers to.",
      "teams_tip": {
        "subtitle": "This profile page is your team’s shared space. As an admin you can set your background wallpapers here and personalize your team’s emails.",
        "title": "Your Pro team is growing…"
      },
      "choose_wallpapers": "Wallpapers",
      "onboarding-step-one-banner": "First things first, your profile needs a URL.\n<strong>You can only set this once (no pressure).</strong>",
      "profile_setup_instruction": "Your profile is where people can send you transfers of up to %{transfer_limit}, even if they don’t have WeTransfer Pro.<br><br>\nCreate a profile with a custom URL. Your profile name can be anything, but keep in mind it will appear on the bottom right of the page.",
      "profile_setup_title": "Setup",
      "profile_url": "Profile URL",
      "upsell": {
        "benefit_one": "Get your own WeTransfer domain",
        "benefit_three": "Design your transfer emails",
        "benefit_two": "Show custom wallpapers when people download your files",
        "button": {
          "action": "Tell me more"
        },
        "heading": "Show off your brand with WeTransfer Pro"
      }
    },
    "verify_email": {
      "success": {
        "change_email": "Want to change your email? Head to %{profile_settings}",
        "profile_settings": "profile settings",
        "received_overview": "received overview",
        "rto_location": "Transfers sent to %{email} will appear in your %{received_overview}, including any transfers sent to you through your personal Pro page.",
        "title": "You’re all set!",
        "cta": "Check it out!"
      },
      "failure": {
        "action": "Send a new link to have another go.",
        "description": "We’re having some trouble confirming your email. ",
        "title": "Something went wrong"
      },
      "success-description": "Transfers sent to %{email} will appear in your received overview, including any transfers sent to you through your personal Pro page.\n\nWant to change your email? Head to profile settings"
    },
    "accountinfo": {
      "pagename": "Account information",
      "signed_in_as": "Signed in as %{name}",
      "sign_out": "Sign out",
      "paid_on": "Paid on",
      "no_invoices": "Your receipts will show up here, but it looks like you haven't got any yet. Lucky you!",
      "subscription_info": "Your Pro subscription of %{deal} will be renewed automatically on %{autorenewal_attempt}.",
      "payment_success": {
        "monthly": "Nice - you’re all set for a full month of WeTransfer Pro",
        "monthly_renewal": "Nice - you’re all set for another month of Pro",
        "yearly": "Nice - you’re all set for a full year of WeTransfer Pro",
        "yearly_renewal": "Nice - you’re all set for another year of Pro"
      }
    },
    "changepassword": {
      "pagename": "Change password"
    },
    "payment": {
      "pagename": "Payment",
      "autorenew_notice": "Your Pro subscription of %{deal} will be renewed automatically on %{autorenewal_attempt}.",
      "will_expire_notice": "Your Pro subscription will <span class='payment__notice'>expire in %{daysBetween} days</span>. Renew your account now or set up automatic renewal.",
      "never_actived_notice": "Your account is not active yet. <a href=\"/payment/retry\">Complete your registration to get started with Pro.</a>",
      "manual_renewal_expiry_notice": "Your Pro account will expire on %{expiry}.",
      "to_checkout": "Go to checkout",
      "updating": "Updating...",
      "yes_disable": "Yes, go ahead",
      "review_billing_link": "Update your payment method?",
      "autorenew_failed": "Your Pro subscription of %{deal}/%{period} will <span class='payment__notice'><strong>expire in %{daysBetween} days</strong>. We couldn't renew your account for you – please renew your account manually before <strong>%{expiry}</strong>.</span>",
      "confirm_disable_autorenew": "Are you sure you want to stop automatic renewal?",
      "disable_autorenewal": "Stop automatic renewal",
      "enable_autorenewal": "Enable automatic renewal",
      "renew_now": "Renew now",
      "subscription_expired": "Your Pro account has expired",
      "cancel_heading": "Time to move on?",
      "cancel_info": "We get it, these things happen. Once you cancel your subscription we’ll hold onto your files for another 30 days (no not under our pillow - don’t make it weird), in case there’s anything you’ve left behind. You can also reopen your subscription whenever you like.",
      "cancel_info_subscription": "We get it, these things happen. Once you cancel your subscription, you’ll be able to use your Pro account until %{subscriptionExpiryDate}. After that we’ll hold onto your files for another 30 days (no not under our pillow - don’t make it weird), in case there’s anything you’ve left behind. You can also reopen your subscription whenever you like.",
      "cancel_now": "Cancel subscription",
      "cancelling": "Cancelling...",
      "confirm_cancel_subscription": "Are you sure you want to cancel your subscription?",
      "confirm_reactivate_subscription": "Excellent choice! Just one more click to reactivate your payment method",
      "manual_renewal_in_future_notice": "Your Pro subscription of %{deal}/%{period} will expire in %{daysBetween} days. You can manually renew your account after %{manual_renewal_available_at}, or activate automatic renewal now.",
      "reactivate_now": "Reactivate Pro",
      "reactivating": "Reactivating...",
      "subscription_cancelled": "Your subscription has been cancelled and will automatically expire in %{daysBetween} days.",
      "subscription_reactivate_expired_notice": "Your Pro account has been cancelled.",
      "subscription_reactivate_notice": "Your Pro account has been cancelled and will be disabled in %{daysBetween} days.\nChanged your mind? Don’t panic, it’s easy to get things back up and running.",
      "update_method_link": "Update payment details",
      "cancellation_cta": "Cancel Pro subscription",
      "cancellation_heading": "No longer need the benefits of Pro?",
      "cancellation_text": "If you cancel your subscription, you’ll be able to use your Pro features until %{subscriptionExpiryDate}. After that, your WeTransfer Pro account will be converted to a free account and your existing transfers will expire 28 days later.",
      "cancellation_text_item_1": "Send up to %{transfer_limit}",
      "cancellation_text_item_2": "Password-protect transfers",
      "cancellation_text_item_3": "Manage and store %{storage_limit} of transfers",
      "cancellation_text_item_4": "Have your own URL and custom Pro page",
      "cancellation_text_item_heading": "A free account only allows you to send %{free_size_limit} per transfer. You’ll no longer be able to:"
    },
    "invoices": {
      "pagename": "Receipts"
    },
    "reviewbilling": {
      "pagename": "Confirm your payment details",
      "information": "In order to change your payment method, we’ll need to renew your subscription at the same time",
      "information_payment": "You will be charged %{deal} for the next %{period} of Pro – your subscription will be good until %{expiry}"
    },
    "renewbilling": {
      "pagename": "Review your information and renew"
    },
    "transfers": {
      "pagename": "Transfers",
      "search": "search for filename",
      "search_results": {
        "one": "%{count} search result",
        "other": "%{count} search results",
        "none": "No results",
        "retry": "Looks like we couldn’t find a transfer matching your search - have another go."
      },
      "space_used": "%{space} of %{totalSpace} used",
      "selected_text": {
        "one": "%{count} transfer selected (%{size})",
        "other": "%{count} transfers selected (%{size})"
      },
      "last_7_days": "Sent in the last 7 days",
      "over_7_days": "Sent more than 7 days ago",
      "sort_on": "Sort by:",
      "size": "Size",
      "name": "Name",
      "date": "Date",
      "delete": "Delete",
      "download": "Download",
      "forward": "Forward",
      "remove": "Delete",
      "select": "Select",
      "copy_link": "Copy link",
      "sent_time_ago": "Sent %{timeAgo} ago",
      "files": {
        "one": "%{count} file",
        "other": "%{count} files"
      },
      "confirm_transfer_delete": "Hold up – are you sure you want to delete this transfer?",
      "confirm_forward": "Forwarding this will replace the transfer in progress. Continue?",
      "confirm_expired_transfer_delete": "This will delete the files and the transfer info forever. Continue?",
      "deleting_now": "We're deleting this for you now",
      "deselect_all_transfers": {
        "one": "Deselect all transfers",
        "other": "Deselect all %{count} transfers"
      },
      "downloads": "Downloads",
      "expiration": "Expiration date",
      "expiration_next": "Expires next %{days}",
      "expiration_no_date": "No expiration date",
      "expiration_not_soon": "Doesn’t expire soon",
      "include_archived_switch_label": "Include info for deleted transfers",
      "include_archived_switch_tooltip": "These don't count towards your storage limit",
      "notify_completed": "Transfer completed. You can close this panel. Or keep looking at it, that's cool too.",
      "preview": "Preview",
      "remove_permanently": "Remove info forever",
      "search_placeholder": "Search by file name or email",
      "select_all_transfers": {
        "one": "Select all transfers",
        "other": "Select all %{count} transfers"
      },
      "space_left": "%{space} of %{totalSpace} left",
      "teams_tip": {
        "subtitle": "This page shows you your own transfer activity. In case you were wondering, your team members can only see their own transfers too.",
        "title": "Your Pro team is growing…"
      },
      "title": "Sent transfers",
      "view_details": "View details",
      "received_time_ago": "Received %{timeAgo} ago",
      "see_all": "See all (%{count})",
      "sender": "Sender"
    },
    "link_downloads_unsubscribe": {
      "body": "You can unsubscribe from notifications about link transfer downloads – you’ll still be able to keep track of downloads in your Sent panel.",
      "cta": "Go to my Sent transfers"
    },
    "transfer": {
      "does_not_expire": "no <u>expiration date</u>",
      "expires_in": "Expires in <span>%{time}</span>",
      "downloaded_at": "Downloaded %{date}, at %{time}",
      "not_downloaded": "Not yet downloaded",
      "email_bounced": "Hmm, the email address you sent this to didn't work",
      "count_files": {
        "one": "%{count} file",
        "other": "%{count} files"
      },
      "sent_datetime": "Sent %{date} at %{time}",
      "never_expires": "No expiration date",
      "and_more": "And %{count} more",
      "read_more": "more",
      "copy_link": "copy link",
      "message": "Message",
      "total_downloads": "Total downloads",
      "sent_to_recipients": {
        "one": "Sent to %{count} person",
        "other": "Sent to %{count} people"
      },
      "no_transfers": "All the transfers you send will appear here",
      "add_first_description": "Check the download status or edit, forward or delete them",
      "mobile": {
        "download": "Download all files",
        "remove": "Delete transfer"
      },
      "delete_datetime": "Files deleted %{date} at %{time}",
      "detail": {
        "plus_download_stats": "Get Pro to keep track of how many times your transfers are downloaded.",
        "plus_password_expiration": "Get Pro to set passwords and expiration dates on your transfers.",
        "plus_transfer_actions": "Get Pro to manage your transfers and delete them anytime.",
        "title": "Your transfer details"
      },
      "download_status_email": "%{count}/%{total} people",
      "download_status_email_text": {
        "zero": "Not yet downloaded",
        "one": "%{count}/%{total} people",
        "other": "%{count}/%{total} people"
      },
      "download_status_link": {
        "one": "one time",
        "other": "%{count} times"
      },
      "download_status_link_text": {
        "zero": "Not yet downloaded",
        "one": "1 time",
        "other": "%{count} times"
      },
      "sent_moment": "Sent %{moment}",
      "total_downloads_tooltip": "Different than you expected? We've recently made a small change. This number shows only completed downloads.",
      "download_status_received_text": {
        "zero": "Not yet downloaded",
        "one": "Downloaded",
        "other": "Downloaded"
      },
      "received_datetime": "Received %{date} at %{time}",
      "received_from": "Received from",
      "received_moment": "Received %{moment}"
    },
    "onboarding": {
      "step_two": {
        "wallpaper": {
          "choose_button": "Pick from gallery"
        },
        "next_button": "All set",
        "description": "Choose a background wallpaper and decide what your profile and download pages look like. Cool, huh? You can upload your own or we've provided a few options."
      },
      "upload_wallpaper": {
        "add_text": "Upload an image",
        "add_description": "For the best possible results, we suggest you upload an image at 2560 x 1600 pixels. Maximum file size is 3MB.",
        "upload_text": "Upload an image or video"
      },
      "preview": {
        "wallpaper_credits_prefix": "Wallpaper by"
      },
      "1": {
        "description": "First up, let’s get your Pro profile sorted.\nThis is what people will see when you send them files.<br /><br />\nYou can name your profile and set the background, so it’s a great way to show off your brand.",
        "next": "Next",
        "skip": "Skip",
        "warning": "<strong>Heads up,</strong> you can only set this once (no pressure!)",
        "welcome": "Welcome to Pro"
      },
      "2": {
        "description": "You can select up to five different backgrounds (or wallpapers as we call them) for your profile.\n\nPut yourself or your brand front and center and deliver your files in your style",
        "pick": "Pick from our gallery",
        "title": "Make an impression with every transfer",
        "upload": "Upload your own"
      },
      "3": {
        "description": "<strong>%{customLink}</strong> is all set up. Now, er, go send stuff.",
        "done": "Done",
        "title": "What a good looking profile"
      }
    },
    "contact": {
      "add_contact": "Add contact",
      "add_first_description": "We'll also save the email addresses you send files to here",
      "add_to_transfer": "Add to this transfer",
      "confirm_delete": {
        "one": "Are you sure you want to delete this contact?",
        "other": "Are you sure you want to delete %{count} contacts?"
      },
      "contact_count": {
        "one": "%{count} contact",
        "other": "%{count} contacts"
      },
      "edit": "Edit",
      "mobile": {
        "add": "Add contact"
      },
      "no_contacts": "Add your first contact!",
      "pagename": "Contacts",
      "remove": "Delete",
      "search_count": {
        "one": "%{count} search result",
        "other": "%{count} search results"
      },
      "search_placeholder": "search for email, name or company",
      "select": "Select",
      "selected_text": {
        "one": "%{count} contact selected",
        "other": "%{count} contacts selected"
      },
      "teams_tip": {
        "subtitle": "When you send someone a transfer, we’ll add them to your contact list. Everyone in your team can build their own list.",
        "title": "Your Pro team is growing…"
      }
    },
    "payment_failed": {
      "change": "Update",
      "complete_order": "Complete your order",
      "description": "Review your details and complete your order",
      "description_error": "Something went wrong — review your details and continue to checkout",
      "description_refused": "We couldn't process your payment — please check your payment details and try again",
      "discount": "Discount",
      "product_description": "One %{duration} of WeTransfer Pro",
      "title": "You're nearly there!",
      "total": "Total",
      "vat": "VAT",
      "your_details": "Your details",
      "your_order": "Your order",
      "title_error": "Hmmm there seems to be an issue",
      "title_refused": "Hmmm there seems to be an issue"
    },
    "unsubscribeexpiration": {
      "button": "Unsubscribe",
      "button_unsubscribed": "Back to WeTransfer",
      "description": "Had enough of our emails? No worries, we can stop reminding you when transfers are about to expire.",
      "description_unsubscribed": "You won’t receive any more emails about expiring transfers",
      "no_email": "you",
      "title": "Unsubscribe from reminder emails",
      "title_unsubscribed": "All done!",
      "downloaded": {
        "body": "Got it. You can unsubscribe from reminders that your transfers are about to expire when your files have already been downloaded. This won’t change whether or not we email you reminders when people haven’t downloaded your files yet.",
        "cta": "Unsubscribe",
        "title": "“My files have been downloaded, I don’t need emails about expiring transfers”"
      },
      "not_downloaded": {
        "body": "No problem. You can unsubscribe from reminders that your transfers are about to expire, even though people haven’t downloaded your files yet.",
        "cta": "Unsubscribe",
        "title": "Don’t need emails about expiring transfers?"
      },
      "pro": {
        "body_1": "That’s cool, you can unsubscribe from these reminders. In your transfer details, you’ll still be able to keep track of when transfers expire and change the expiration dates whenever you want.",
        "body_2": "Psst, you can hit us up at <a href=\"mailto:pro@wetransfer.com\">pro@wetransfer.com</a> if you change your mind or get stuck with anything—no hard feelings.",
        "cta": "Unsubscribe",
        "title": "Don’t need emails about expiring transfers?"
      }
    },
    "about": {
      "legal": {
        "actionbar": {
          "plus": {
            "text": "wait a second.... you will be logged out to complete this action"
          },
          "text": "Are you sure you want to clear your cookies?"
        }
      }
    },
    "about_plus": {
      "checklist": {
        "title": "Upgrade to Pro today for %{currency}%{price}/month"
      }
    },
    "billinginfo": {
      "pagename": "Billing information"
    },
    "help": {
      "button_all_answers": "More answers",
      "page_title": "Quick Help",
      "read_more": "Read more",
      "search_button": "Search",
      "search_placeholder": "What can we help you with?"
    },
    "payment_cancel": {
      "cancel": "Go back",
      "info": "Tell us your reason for leaving and we’ll continue to improve WeTransfer Pro with you in mind.",
      "pagename": "Before you go",
      "yes_disable": "Yes, go ahead"
    },
    "payment_methods": {
      "bancontact": "Bancontact",
      "card": "Credit card",
      "card_cvc": "CVC",
      "card_expiration": "MM / YY",
      "card_name": "Name on card",
      "card_number": "Card number",
      "complete_payment": "Complete your payment",
      "creditcard": "Credit card",
      "discount": "Discount",
      "do_not_refresh": "Try and resist the temptation to refresh or close this page",
      "ideal": "iDEAL",
      "ideal_info": "iDEAL is an online payment method used in the Netherlands where users can pay directly from their bank account",
      "info": "Update payment method",
      "info_content": {
        "month": "- After the initial payment you'll be charged %{price} every month (unless you decide to cancel your Pro subscription - but you wouldn't, right? Right?!) \n- Don't worry, you can find the option to cancel in Account Settings > Payment. \n- You can always update your payment method and/or business details before your next payment is due.",
        "year": "- After the initial payment you'll be charged %{price} once a year (unless you decide to cancel your Pro subscription - but you wouldn't, right? Right?!)\n- Don't worry, you can find the option to cancel in Account Settings > Payment.\n- You can always update your payment method and/or business details before your next payment is due."
      },
      "payment_in_progress": "Processing your payment...",
      "paypal": "PayPal",
      "plan_details": {
        "month": "Monthly",
        "year": "Yearly"
      },
      "plan_name": "WeTransfer Pro",
      "price_period": {
        "month": "/month",
        "year": "/year"
      },
      "select_bank": "Select your bank",
      "select_country": "Select country",
      "sofort": "SOFORT",
      "tax": "VAT",
      "title": "Select your payment method",
      "total": "Total"
    },
    "payment_pending": {
      "order_in_progress": "Loading..."
    },
    "payment_update": {
      "bancontact": {
        "info": "Heads up – to check your details are correct Bancontact will charge a one-time fee of €0.50"
      },
      "confirm_update": "Confirm",
      "ideal": {
        "info": "Heads up – to check your details are correct iDEAL will charge a one-time fee of €0.01"
      },
      "info": "Heads up – to check your details are correct iDEAL will charge a one-time fee of €0.01",
      "sofort": {
        "info": "Heads up – to check your details are correct SOFORT will charge a one-time fee of €1"
      },
      "title": "Update payment details",
      "update_in_progress": "Updating your details..."
    },
    "sign_in": {
      "account": "Don't have an account?",
      "upgrade": "Upgrade to WeTransfer Pro"
    },
    "signin": {
      "account_cta": "Create an account",
      "account_item_1": "Send up to %{size_limit}",
      "account_item_2": "Manage transfers",
      "account_item_3": "Store up to %{storage_limit}",
      "account_subtitle": "Free",
      "plus_cta": "Get WeTransfer Pro",
      "plus_item_1": "Send up to %{size_limit}",
      "plus_item_2": "Manage transfers",
      "plus_item_3": "Store up to %{storage_limit}",
      "plus_item_4": "Your own backgrounds",
      "plus_item_5": "A custom URL",
      "plus_item_6": "Password-protect transfers",
      "plus_month": "/month"
    },
    "projects": {
      "transfer_actions": {
        "download": "Download",
        "remove": "Delete",
        "rename": "Rename",
        "view": "View",
        "cancel": "Cancel",
        "preview": "Preview"
      },
      "added_at": "at %{timeOfDay}",
      "clipboard_modal": {
        "copy_link": "Copy link",
        "link_copied": "Link copied to clipboard",
        "content_label": "Copy link to this project",
        "list_item_1": "Download and view access only",
        "list_item_2": "Link stays the same, forever",
        "title": "Share project"
      },
      "content": {
        "create_transfer_button": "Add your files",
        "empty_state": "Your project is currently empty. Get started by adding some files to start your project timeline.",
        "pending_transfer_button": "Working on it..."
      },
      "logo_title": "Go back to wetransfer.com",
      "logo_tooltip_caption": "Back to WeTransfer",
      "onboarding": {
        "description": "Create a project to simplify the way you transfer. Add different versions and share multiple transfers with just one link.",
        "title": "One place to share all your work",
        "banner": "Heads up! You’re one of a chosen few with access to Projects while it is still being built (and improved on). We might reach out to you for feedback."
      },
      "processing": "Processing..",
      "timestamp": "%{timeAgo} ago",
      "actions": {
        "discard": "Discard changes",
        "edit": "Edit",
        "remove_transfer": "Delete this transfer? Files will be removed from this project and sent transfers.",
        "save": "Save",
        "share": "Share"
      },
      "chat": {
        "owner_button_label": "Psst… Talk to us",
        "owner_offline_greeting": "We’re currently offline, but let us know what you’re having trouble with and we’ll get back to you within one business day.",
        "owner_online_greeting": "Let us know what you’re having trouble with and we’ll get back to you as soon as we can",
        "receiver_button_label": "Questions? We’re here to help",
        "receiver_offline_greeting": "Let us know what you’re having trouble with and we’ll get back to you as soon as we can.",
        "receiver_online_greeting": "Let us know what you’re having trouble with and we’ll get back to you as soon as we can."
      },
      "created_by": "Created by %{user}",
      "created_by_fallback": "Created",
      "errors": {
        "blank": "This is not the Project you’re looking for…",
        "limit": "Your potential is infinite, but you've reached your character limit",
        "required": "You know the drill. You can’t skip filling this out"
      },
      "event": {
        "project_created_byline": "Add some files to show what you’re working on.",
        "project_created_title": "Start of project"
      },
      "just_now": "just now",
      "labels": {
        "description": "Description",
        "name": "Name",
        "new_name": "Name your project",
        "uploading": "Uploading"
      },
      "logo": {
        "cta": "Add a logo",
        "errors": {
          "dimensions": "Your logo is smaller than 220 x 220 px. Try a bigger image",
          "general": "Hmm, something went wrong. Please give it another go",
          "size": "Your logo is bigger than 5 MB. Try a smaller file",
          "type": "Your logo is not a JPEG, GIF, or PNG. Try a different image"
        },
        "instructions": "Your logo can be up to 5 MB. JPEGs and GIFs are okay, but PNGs with a transparent background work best",
        "instructions-title": "Show off your brand"
      },
      "name_modal": {
        "content_label": "Name or rename your Project",
        "input_placeholder_0": "Definitely a Cannes Lion",
        "input_placeholder_1": "A cure for the common cold",
        "input_placeholder_2": "The perfect crime",
        "input_placeholder_3": "I Write Songs Not Titles",
        "input_placeholder_4": "Award-Winning Idea",
        "input_placeholder_5": "Brand New Brand Campaign",
        "input_placeholder_6": "World domination",
        "save": "Save",
        "text": "Describe what you’re working on.",
        "title": "Name your project"
      },
      "new_project_label": "Start new project",
      "noticebar": {
        "button-cancel": "Cancel",
        "button-close": "Close",
        "button-delete": "Delete",
        "button-no": "No",
        "button-share": "Share",
        "button-yes": "Yes",
        "confirm-cancel": "Cancel this transfer?",
        "confirm-complete": "Upload complete! Let everyone know that you’ve added more files.",
        "confirm-delete": "Delete this transfer?",
        "confirm-first-complete": "Upload complete! Share this project for your files to be downloaded.",
        "general_error": "Yikes, something went wrong. Please try again."
      },
      "pagename": "Projects",
      "placeholders": {
        "description": "Give your project a brief description"
      },
      "project": {
        "notification": {
          "name_saved": "Name saved! Your project sounds like a winner."
        }
      },
      "rename_form": {
        "label": "Name this transfer"
      },
      "share_button_label": "Share",
      "unnamed_project_title": "Unnamed Project",
      "uploader": {
        "additional_file_amount": "+ %{amount} files"
      },
      "uploads": {
        "zero": "No uploads yet",
        "one": "upload",
        "other": "uploads"
      },
      "watch_video": "Watch video"
    },
    "teams": {
      "invitee": {
        "action_cancel_invite": "Cancel invite"
      },
      "invitees": {
        "title": "Invited – awaiting response"
      },
      "member": {
        "action_demote": "Remove as admin",
        "action_promote": "Make admin",
        "action_revoke": "Take off team"
      },
      "members": {
        "title": "On your team"
      },
      "no_access": {
        "description": "Stay tuned, we’ll let you know when it’s ready. ",
        "title": "Oops, looks like this feature is still top secret. "
      },
      "subtitle": {
        "members": {
          "one": "%{count} member",
          "other": "%{count} members"
        },
        "pending": "%{pendingCount} invited"
      },
      "tip": {
        "button": "Learn more",
        "subtitle": "With our brand new Pro for Teams feature, we’ve made the best WeTransfer experience even better! Add new members for free. Use the super-simple form below to get your team going – once they accept your invite you are good to go!",
        "title": "There’s no i in team..."
      },
      "title": "Team"
    },
    "transfer_progress": {
      "meta": {
        "expires_in": "Expires in %{expiry}"
      },
      "recipients": "Sending to",
      "upsell": {
        "benefit_one": "See when your files were downloaded",
        "benefit_three": "Review and resend your old transfers",
        "benefit_two": "See who downloaded your files",
        "button": {
          "action": "Tell me more",
          "cancel": "No, thanks"
        },
        "experiment": {
          "benefit_1": "Send and receive bigger files",
          "benefit_2": "Decide when your transfers expire",
          "benefit_3": "Delete or resend transfers",
          "benefit_4": "Set passwords on transfers",
          "benefit_5": "Send and receive up to 20GB",
          "benefit_6": "You decide when transfers expire",
          "benefit_7": "See who has downloaded your files",
          "benefit_8": "Review, delete and resend any transfer",
          "cta_1": "Yes, I want that",
          "heading_1": "Take control of your transfers with WeTransfer Pro",
          "heading_2": "Want a bigger and better WeTransfer?"
        },
        "heading": "Manage your transfers easily with WeTransfer Pro",
        "title": "Your transfer details"
      }
    },
    "unsubscribeonboarding": {
      "action": "Unsubscribe",
      "back": "Back to WeTransfer",
      "contact": "Psst, if you get stuck with anything you can hit us up at <a href=\"mailto:pro@wetransfer.com\">pro@wetransfer.com</a> — no hard feelings.",
      "done": "All done!",
      "message": "You can unsubscribe from our introduction emails — don’t worry, you’ll still get the important stuff.",
      "title": "Inbox getting busy?"
    },
    "userinfo": {
      "pagename": "Personal details"
    },
    "yourapps": {
      "description": "You’re logged into Pro on these apps.",
      "device": {
        "connected_on": "Connected on %{date}",
        "last_used": "Last used on %{date}, %{time}"
      },
      "no_devices_description": "If you’re logged into Pro on any of our apps, they’ll appear here. <a href=\"https://wetransfer.zendesk.com/hc/en-us/articles/360000465643\" rel=\"external\">Find out more</a>.",
      "pagename": "Your apps",
      "unknown_device": "Unknown device"
    },
    "password_and_security": {
      "title": "Password and security",
      "two-factor-authentication": {
        "description": {
          "enabled": "Since %{date}"
        },
        "disable": "Turn off",
        "done": "Done",
        "enable": "Turn on",
        "get_recovery_codes": "Get recovery codes",
        "next_step": "Next",
        "recovery_code_action": "Generate new codes",
        "recovery_code_keep_safe": "Each code can only be used once, but you can always get more if you need them.",
        "recovery_code_need_more": "Need more recovery codes? You can always generate new ones, just keep in mind that this will make all the current codes invalid.",
        "recovery_code_title": "Your recovery codes",
        "require_password_action": "Enter",
        "require_password_text": "Enter your password to continue",
        "step_one_action": {
          "app_store": "Download on App Store",
          "google_play": "Get it on Google Play"
        },
        "step_one_label": "Step 1 (of 3)",
        "step_one_text": "You will need an authenticator app on your phone. If you already have Google Authenticator (or a different app), click next.",
        "step_one_title": "Download Google Authenticator",
        "step_three_label": "Step 3 (you’re all set!)",
        "step_three_text": "If you need to log in and don’t have your phone with you (we hear that it does happen), you can use one of these recovery codes. We won’t save these codes for you or show them to you again, so grab them now—and be sure to keep them as safe as the passcode to your bank account.",
        "step_three_text_2": "Keep these codes as safe as your password to your bank account! Each code can only be used once.",
        "step_three_title": "Save recovery codes",
        "step_two_form": {
          "error": "Uh-oh, that code is wrong or expired",
          "label": "Verification code"
        },
        "step_two_label": "Step 2 (halfway there)",
        "step_two_text": "Use your authenticator app to scan this barcode. The app will generate a six-digit verification code; enter that code below.",
        "step_two_text_mobile": "Enter this key in your authenticator app. The app will generate a six-digit verification code; enter that code below.",
        "step_two_title": "Scan barcode",
        "step_two_title_mobile": "Enter key",
        "text": {
          "protect_account": "Use your phone to add an extra layer of security to your account."
        },
        "title": "Two-factor authentication"
      }
    }
  },
  "exception": {
    "activate_subscription_exception": "Hmm, something went wrong - please try again or contact us through our <a href=\"https://wetransfer.zendesk.com\" rel=\"external\">help center</a>",
    "complete_payment_exception": "Hmm, something went wrong - please try again or contact us through our <a href=\"https://wetransfer.zendesk.com\" rel=\"external\">help center</a>",
    "retrieve_checkout_exception": "Hmm, something went wrong - please try again or contact us through our <a href=\"https://wetransfer.zendesk.com\" rel=\"external\">help center</a>",
    "source_id_error": "Sorry, we couldn't process this request — please try again",
    "three_d_secure": "We currently don't support 3D Secure cards.",
    "something_went_wrong": "Hmm, something went wrong - please try again or contact us through our <a href=\"https://wetransfer.zendesk.com\" rel=\"external\">help center</a>",
    "signin_no_data_exception": "Hmm, something went wrong - please check your username and password and try again",
    "signin_exception": "Sorry, we couldn't sign you in – please try again",
    "signout_exception": "Hmm, it appears we couldn't sign you out. Weird. Please refresh this page to check if you're still signed in.",
    "signup_account_error": "Hmm, something went wrong during sign-up – please check your details and try again",
    "retrieve_account_exception": "Hmm, something went wrong. We hate to ask, but please try again?",
    "update_account_error": "Sorry, we couldn't update your account details. Could you try again?",
    "retrieve_subscription_exception": "We couldn't find your payment details - please try again",
    "update_subscription_exception": "We couldn't update your payment details - please try again or contact us through our <a href=\"https://wetransfer.zendesk.com\" rel=\"external\">help center</a>",
    "autorenewal_not_supported": "Auto-renewal is not supported for this account",
    "update_password_exception": "Sorry, we couldn't update your password – please try again",
    "retrieve_device_exception": "We couldn't find any connected devices. Not one! Please try again.",
    "remove_device_exception": "We could not remove this device",
    "renew_subscription_exception": "We couldn't renew your account right now – please try again later",
    "invoices_retrieve_exception": "We couldn't find your receipts – please try again",
    "invoice_download_exception": "We couldn't download this receipt – please try again",
    "image_not_valid": "Hmm, it looks like this image cannot be uploaded",
    "update_profile_error": "Hmm, we couldn't update your profile – please try again",
    "retrieve_profile_exception": "We couldn't find your profile settings – please try again",
    "s3_exception": "Hmm, something went wrong during your upload – please try again",
    "file_size_limit_reached": "Bigger isn't always better – please upload an image 3MB or smaller",
    "retrieve_transferlist_exception": "We could not find your list of transfers",
    "retrieve_transfer_exception": "We could not find your transfer details",
    "delete_transfer_exception": "We could not delete this transfer",
    "delete_transfers_exception": "We could not delete these transfers",
    "update_expiry_exception": "We could not update this expiration date",
    "add_contact_exception": "We could not add this contact",
    "complete_last_order_exception": "We couldn't complete your order",
    "edit_contact_exception": "We could not update this contact",
    "remove_contact_exception": "We could not delete this contact",
    "request_password_reset_exception": "Sorry, we couldn't process this reset request — please try again",
    "request_password_reset_no_user": "We don't recognize this email address - please double-check and try again",
    "reset_password_error": "Something went wrong while resetting your password — please try again",
    "reset_password_exception": "Sorry, we couldn't reset your password at the moment — please try again",
    "reset_password_token_invalid": "Hmm, this reset link didn't work — please follow the instructions we have emailed you, or start again",
    "retrieve_last_order_exception": "We couldn't find your order",
    "retrieve_ternot_exception": "Hmm, we are having trouble finding your transfer – please try again",
    "signin_invalid_credentials": "This email address and password don't seem to match — please double-check and try again",
    "unsubscribe_expiration_exception": "Something went wrong while unsubscribing you – please try again",
    "unsubscribe_expiration_invalid_signature": "Hmm, this unsubscribe link didn't work — please try again",
    "cancel_subscription_exception": "Looks like something went wrong and we couldn't cancel your subscription, please try again later.",
    "change_team_member_role_error": "Sorry we couldn't change this person's role – please refresh to try again",
    "duplicate_invitation_to_team_error": "This person has already been invited to another team",
    "duplicate_student_email": "Email already used or not an .edu email",
    "duplicate_student_email_eu": "Email already used",
    "email_background_upload_validation_error": "This file is too big, or not a png or jpg format - try a different image",
    "email_background_upload_validation_error_videos": "This file is too big, or not a png or jpg format - try a different image",
    "faculty_coupon_error": "Hmm, something went wrong. We hate to ask, but please try again?",
    "invite_to_team_error": "There was an error sending this invite, please try again",
    "payment_cancelled": "Hmm, something went wrong - please try again or contact us through our <a href=\"https://wetransfer.zendesk.com\" rel=\"external\">help center</a>",
    "profile_picture_upload_validation_error": "This file is too big, or not a png or jpg format - try a different image",
    "reactivate_subscription_exception": "Something went wrong, please try again",
    "remove_team_member_error": "Sorry we couldn't remove this person – please refresh to try again",
    "retrieve_contactlist_exception": "We could not find your list of contacts",
    "retrieve_team_invitation_exception": "Sorry we couldn't load your invite – please refresh to try again",
    "retrieve_team_invitations_exception": "Sorry we couldn't load your invites – please refresh to try again",
    "retrieve_team_members_exception": "Sorry we couldn't load your team – please refresh to try again",
    "source_retrieve_error": "Hmm, something went wrong - please try again or contact us through our <a href=\"https://wetransfer.zendesk.com\" rel=\"external\">help center</a>",
    "student_coupon_error": "Hmm, something went wrong. We hate to ask, but please try again?",
    "token_error": "Something went wrong. Maybe try again?",
    "unsupported_student_email": "Please use an .edu email address",
    "update_user_error": "There was a problem updating your information",
    "wallpaper_upload_validation_error": "This file is too big, or not a png or jpg format - try a different image",
    "wallpaper_upload_validation_error_videos": "Oops, looks like your video doesn’t fit our requirements — have another go",
    "declined_contact_bank_error": "Sorry, we couldn't process this payment — please contact your bank",
    "invalid_password": "Password not recognized",
    "otp_token_invalid": "Uh-oh, that code is wrong or expired",
    "projects_create_exception": "We currently can't create a new project",
    "projects_load_exception": "We currently can't load your projects",
    "update_information_throttle": "There was a problem updating your information. Take a %{throttle_time} break before you try again."
  },
  "navigation": {
    "about_us": {
      "items": {
        "products": "Products",
        "about": "WeTransfer",
        "plus": "Pro",
        "apps": "Apps",
        "advertise": "Advertise",
        "upgrade": "Upgrade"
      },
      "name_1_2019": "About us",
      "name": "About us"
    },
    "change_background": "Change background",
    "home": {
      "name": "Home"
    },
    "help": {
      "name": "Help"
    },
    "got_plus": {
      "name": "Got Pro?"
    },
    "signed_in": {
      "name": "Pro"
    },
    "user": {
      "items": {
        "transfers": "Transfers",
        "contacts": "Contacts",
        "profile": "Profile",
        "account": "Account",
        "received": "Received",
        "sent": "Sent",
        "teams": "Team",
        "projects": "Projects"
      }
    },
    "feedback": {
      "name": "Feedback"
    },
    "sign_out": "Sign out",
    "signin": {
      "name": "Sign in"
    },
    "login": "Log in",
    "signup": "Sign up"
  },
  "release_notes_notification": "We’ve got some shiny, new product updates <a href=\"/release-notes\">Find out more</a>",
  "site": {
    "titles": {
      "products": "Products | WeTransfer",
      "about": "About | WeTransfer",
      "advertise": "Advertise with us | WeTransfer",
      "apps": "Free apps for Mac, iOS and Android | WeTransfer Apps",
      "forgot_password": "Reset your password | WeTransfer Pro",
      "help": "How to send large files | WeTransfer Help",
      "home": "Share large files easily for free | WeTransfer",
      "plus": "Upgrade to send bigger files | WeTransfer Pro",
      "sign_in": "Log in | WeTransfer",
      "sign_up": "Sign up | WeTransfer Pro",
      "upgrade": "Upgrade | WeTransfer Pro"
    },
    "name": "WeTransfer"
  },
  "splash": {
    "heading": {
      "line_1": "WeTransfer is the best way to send big files",
      "line_1_unlimited": "We also have a premium service with a bunch of extra features",
      "line_2": "<b>WeTransfer Pro</b> makes it even better",
      "line_2_unlimited": "Check out <b>WeTransfer Pro</b> or continue to WeTransfer ",
      "line_1_free": "WeTransfer is the best way to send big files",
      "line_2_free": "Get more out of WeTransfer",
      "free_account": "Welcome back. Would you like to make this official?"
    },
    "plan": {
      "free": {
        "cta": "Take me to Free",
        "cta_unlimited": "Continue to WeTransfer",
        "feature_1": "Send up to %{free_transfer_limit}",
        "feature_3_unlimited": "Wave goodbye to ads",
        "feature_4_unlimited": "Style your own page",
        "feature_5_unlimited": "Manage your transfers",
        "feature_6_unlimited": "Password protect files",
        "heading": "WeTransfer Free"
      },
      "plus": {
        "cta": "Get WeTransfer Pro",
        "cta_unlimited": "Tell me more",
        "feature_1": "Send up to %{plus_transfer_limit}",
        "feature_2": "Customize your backgrounds",
        "feature_3": "Keep transfers for longer",
        "feature_4": "Protect your transfers",
        "heading": "WeTransfer Pro",
        "more_features": "Plus a whole lot more",
        "feature_10": "Customize your emails",
        "feature_11": "Store up to %{plus_storage_limit}",
        "feature_12": "Decide when transfers expire",
        "feature_13": "Password-protect your transfers",
        "feature_7": "Personalize your profile",
        "feature_8": "Create your own address book",
        "feature_9": "Customize your WeTransfer url"
      },
      "pro": {
        "feature_new": "New!",
        "cta": "Get WeTransfer Pro",
        "feature_1": "%{storage_limit_pro} storage",
        "feature_2": "Send and receive up to %{transfer_limit_pro}",
        "feature_3": "Resend and delete transfers",
        "feature_4": "Password-protect transfers",
        "feature_5": "Your own Pro page and URL",
        "heading": "WeTransfer"
      },
      "free_account": {
        "cta": "Sign up for free",
        "feature_1": "No storage",
        "feature_2": "Send up to %{free_transfer_limit}",
        "feature_3": "Resend and delete transfers",
        "heading": "WeTransfer Account",
        "price_label": "Free forever"
      }
    },
    "footer": {
      "or": "or",
      "send_files": "I just want to send my files",
      "no_thanks": "No thanks"
    }
  },
  "transfer": {
    "bubble": {
      "collection": {
        "download_links": "You can’t download Boards which only contain links"
      },
      "download_links": {
        "read_more": "Read more"
      },
      "mp3_receiver": {
        "copy": "Listen up – mp3 files sent by Pro users can now be played before they are downloaded",
        "more": "Learn more",
        "title": "Introducing audio previews"
      },
      "mp3_sender": {
        "copy": "Listen up – mp3 files you send can now be played before they are downloaded",
        "more": "Learn more",
        "title": "Introducing audio previews"
      },
      "buttons": {
        "check_out": "Check it out!",
        "help": "Help Center",
        "plus": "Get Pro",
        "get_link": "Get link"
      },
      "errors": {
        "begins_space": "We can't send files whose names begin with a space. Please rename and try again.",
        "begins_stop": "We can't send files whose names begin with a full stop. Please rename and try again.",
        "blocked": "We couldn't load WeTransfer – you appear to be blocked",
        "generic": "We're sorry to say something went wrong during your transfer",
        "has_blackslash": "We can't send files whose names include a backslash. Please rename and try again.",
        "has_linebreak": "We can't send files whose names include a line break. Please rename and try again.",
        "incorrect_recipient": "It looks like one of the email addresses you entered is incorrect",
        "incorrect_sender": "It looks like there is a problem with your email address",
        "io_error": "There is an issue with your files",
        "long_filename": "We can't send files whose names have more than 250 characters. Please rename and try again.",
        "long_message": "That message is a bit too long – please make it shorter",
        "missing_default_recipient": "Only registered WeTransfer Pro email addresses can receive more than %{free_transfer_limit}. Refresh the page to start again.",
        "no_clipboard": "It looks like you haven't copied the link",
        "no_files": "It seems you haven't added any files yet!",
        "no_folders": "You need to zip/compress your folder before we can send it",
        "no_recipient": "We need the email address you want to send these files to",
        "no_sender": "We just need your email address now and we're good to go",
        "too_big": "Whoa there – we can't transfer more than %{upload_limit} at a time",
        "too_many_recipient": "Oops – %{count} people is our limit. Need more? Why not use a link transfer.",
        "unavailable": "Sorry, this transfer has been deleted and is not available any more",
        "wrong_password": "Hmm, that password isn't right. Please try again or check with the person who sent you this transfer?",
        "default_title": "Whoops!",
        "duplicate_filename": "We can't send multiple files with the same name. Please rename and try again.",
        "firstaccept": "You need to approve first, before sending",
        "not_downloadable": "Hmm, something went wrong while getting your files. Please reload the page and try again.",
        "recaptcha": {
          "text": "Something went wrong. Please try again!",
          "title": "Uh-oh..."
        },
        "too_big_text": "You can’t transfer more than %{upload_limit} at a time. Send up to %{plus_limit} with Pro. ",
        "too_big_title": "Hey big sender",
        "too_many_files": "You can't send more than %{count} files at the same time",
        "too_many_recipient_text": "You can transfer files to up to 50 people with Pro.",
        "too_many_recipient_title": "That's too many people",
        "unavailable_forward": "Unfortunately it looks like this transfer has been deleted so it can't be forwarded",
        "verify": {
          "button": "New code please!",
          "text": "Try again or request a new code. ",
          "title": "Whoops!"
        }
      },
      "tips": {
        "change_type": "Send your transfer link in an email or generate a link to share how you want",
        "contacts": "Anyone you send files to will be automatically added to your contacts",
        "expiry": "With WeTransfer Pro you decide when transfers expire. (You can even change the expiration date after a transfer’s been sent!)",
        "free_limit": "Good news, you can send up to %{size} at a time. Better news, you can use the service as often as you like!",
        "message": "If you'd like, add a message to go with your transfer here",
        "password": "You can password-protect a transfer for added security. Please note we don't add the password into the email so you'll need to give it to the right people!",
        "recipient_limit": "Add up to %{email_limit} emails or open the menu next to the transfer button to create a link",
        "transfer_history": "Your transfer is stored in your transfer overview",
        "your_email": "Pop your own email address in here so we can let you know when your files have been downloaded",
        "growth_exp_2_desktop": "WeTransfer is the simplest way to send your files around the world.\n\nNeed to share something that’s too big for email with your friends, family, colleagues or clients?",
        "growth_exp_2_desktop_button": "Give us a try…",
        "growth_exp_2_mobile": "WeTransfer is the simplest way to send your files around the world.",
        "link_transfer": "Did you know you can get your transfer link instead?",
        "previews_receiver": "Images sent by Pro users can be previewed before downloading. Just click on a file to see what’s inside!",
        "previews_sender": "Images you send can now be previewed before they're downloaded",
        "self_send_text": "Save yourself a job and use a link instead",
        "self_send_title": "Psst, sending to yourself?",
        "vrl_text": "You can now have a look at your files without having to download them.",
        "vrl_title": "Preview your files",
        "zip_text": "Sending a folder? We'll zip it for you",
        "zip_title": "No need to zip",
        "anonymous_sender": {
          "button": "Get a link",
          "text": "Pop in your email and we’ll let you know when your files get downloaded.\n\nYou’ll need to verify your email so we know it’s really you. Don’t want to verify every time?",
          "text_locked_recipient": "Pop in your email and we’ll let you know when your files get downloaded.\n\nYou’ll need to verify your email so we know it’s really you."
        },
        "prefer_link": {
          "button": "Get a link",
          "text": "Don’t want to verify your email? That’s okay."
        }
      },
      "button": {
        "previews_receiver_learnmore": "Learn more",
        "previews_sender_learnmore": "Learn more"
      },
      "recipient_locked_text": "This page is for the owner to receive files. Log in if that’s you, or head to <a href=\"https://wetransfer.com\">wetransfer.com</a> to send to anyone else.",
      "recipient_locked_title": "Heads up",
      "title": {
        "previews_receiver": "Introducing image previews",
        "previews_sender": "Introducing image previews"
      }
    },
    "collection": {
      "deleted": {
        "copy": "Sorry, this Board has been deleted and is not available anymore",
        "title": "Board deleted"
      },
      "empty": {
        "copy": "Hmm, this Board seems to be empty"
      },
      "uploading": {
        "copy": "Preparing your Board",
        "title": "We're nearly ready..."
      }
    },
    "download": {
      "blocked": {
        "link": "Find out more",
        "text": "This transfer has been reported and can’t be downloaded",
        "title": "Transfer unavailable"
      },
      "title": "Ready when you are",
      "expires": "Transfer expires in %{relative_time}",
      "expires_never": "No expiration date",
      "files": "%{count} files, %{size}",
      "format": "%{files}・%{expires}",
      "expand": "more",
      "download_link": "Download link",
      "files_nosize": {
        "one": "%{count} file",
        "other": "%{count} files"
      },
      "show_all_files_mobile": "Show all files",
      "zip_information": "You will receive a .zip file when you download all files at once - <a href=\"https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device\" rel=\"external\">read more</a>"
    },
    "preview": {
      "open_grid": "Preview",
      "click_to_open": "Click to preview",
      "grid": "Items in this transfer",
      "link": "Website",
      "not_previewable": "Preview not available",
      "now_open": "Preview open",
      "open_link": "Open link in new tab",
      "open_link_short": "Open link",
      "overview": "overview",
      "reload": "Reload",
      "something_went_wrong": "Oops, something went wrong",
      "tap_to_open": "Tap to preview",
      "toobig_copy": "We can only preview images up to 50MB – <a href=\"https://wetransfer.zendesk.com/\" rel=\"external\">read more here</a>",
      "toobig_title": "Oof – this image is too big to preview",
      "unsupported_copy": "Check out <a href=\"https://wetransfer.zendesk.com/hc/en-us/articles/115003447483\" rel=\"external\">this article</a> to find out which files we can preview",
      "unsupported_title": "We can’t preview this file (yet)",
      "visit_website": "Visit website"
    },
    "complete_mobile": {
      "email_text": "The download email has been sent – your transfer is available for %{expires}",
      "link_text": "Copy your download link:",
      "email_text_no_expiry": "An email has been sent to the receiver."
    },
    "consent-manager": {
      "button-accept": "I accept",
      "button-accept-all": "Accept all",
      "button-reject": "No thanks",
      "button-save-and-exit": "Save and close",
      "headline": "Cookies and advertising",
      "intro": "We use the money we make from our beautiful advertisements to help pay our bills. That’s how we can afford to provide our file-sharing service for free.",
      "manage-cookies": "Manage cookies",
      "partners-headline": "Our partners",
      "partners-text": "<p>Here’s an alphabetical list of the carefully selected partners we allow to measure your data so we can track and improve performance.</p>",
      "preferences-headline": "Manage cookies ",
      "preferences-text": "<p>We respect your right to privacy and your choices regarding your data. We need to process some of your personal information when you’re using our tools, but we’re committed to a responsible and values-driven approach to business, tech, and our relationship with you.</p>\n<p>That’s why we go to great lengths to keep your digital footprint small, safe, and in your control.</p>\n<p>By default we only collect and process data when strictly necessary. However, if you’d like to support our service and keep WeTransfer free, please allow us to share information with our advertising partners.</p>",
      "preferences-text-allow-cookies": "Allow cookies so we and/or our partners can:<br><br>",
      "purpose-description-first-intro": "To promote products on and outside of our website and apps, WeTransfer can: ",
      "purpose-description-first-list": "<ul><li>Collect information about how you interact with our website(s), such as click behaviour and visited pages, and (when possible) combine this information with data that we have saved about you, such as your account email address</li><li>Use the information we collect to provide you with offers and promotions via email; on our own website(s) or apps; and on websites or apps of third parties. For example, we might promote one of our other products to you when you use WeTransfer Pro.</li></ul>",
      "purpose-description-second-intro": "To promote products on and outside of our website and apps, our partners can: ",
      "purpose-description-second-list": "<ul><li>Collect information about how you interact with our website(s), such as click behaviour and visited pages, and (when possible) combine this information with data they have saved about you</li><li>Use the information they collect to provide you with offers and promotions via email; on their own website(s) or apps; and on websites or apps of third parties they work with.</li></ul>",
      "purpose-title": "Promote products on and outside of our website and apps",
      "switch-by-partners": "By partners",
      "switch-by-we-transfer": "By WeTransfer",
      "text": "<p>Our website uses <a href=\"%{href}\">cookies</a> that help it to function, allow us to analyze how you interact with it, and help us to improve performance.</p>\n<p>Do you also want to allow cookies from our advertising partners so we can personalize the ads you see, as well as promote products by WeTransfer and our partners on and outside our websites and apps?</p>"
    },
    "terms_conditions": {
      "title": "First up...",
      "text": "To continue, please agree to our <a href=\"/legal/terms\" data-route-type=\"plus\">Terms of Service</a> and <a href=\"/legal/privacy\" data-route-type=\"plus\">Cookie Policy</a>. We use cookies for functional and analytical purposes and third party cookies for advertising purposes.",
      "language": "Your language is set to",
      "button": "I agree"
    },
    "form": {
      "num_files": {
        "one": "%{count} file added · %{remaining} remaining",
        "other": "%{count} files added · %{remaining} remaining"
      },
      "add_files": "Add your files",
      "more_files": "Add more files",
      "available_space": "Add up to %{size}",
      "message": "Message",
      "from": "Your email",
      "to": "Email to",
      "other_recipients": {
        "one": "+%{count} other",
        "other": "+%{count} others"
      },
      "reset_forward": "Cancel this forward",
      "drop_files": "or drag and drop",
      "files_count": {
        "one": "%{count} file added · %{fileSize} in total",
        "other": "%{count} files added · %{fileSize} selected"
      },
      "select_folder": "Or select a folder"
    },
    "progress": {
      "title": "Transferring...",
      "title_cancel": "Cancel this transfer?",
      "uploaded": "%{sent} of %{total} uploaded",
      "remaining": {
        "minutes": {
          "zero": "Less than 1 minute remaining",
          "one": "About 1 minute remaining",
          "other": "About %{count} minutes remaining"
        },
        "hours": {
          "one": "About 1 hour remaining",
          "other": "About %{count} hours remaining"
        }
      },
      "document_title": "%{percentage}% - Transferring...",
      "meta": {
        "email": {
          "one_file_one_recipient": "Sending %{filesCount} file to %{recipientsCount} person",
          "one_file_other_recipients": "Sending %{filesCount} file to %{recipientsCount} people",
          "other_files_one_recipient": "Sending %{filesCount} files to %{recipientsCount} person",
          "other_files_other_recipients": "Sending %{filesCount} files to %{recipientsCount} people"
        },
        "link": {
          "one": "Sending %{count} file",
          "other": "Sending %{count} files"
        }
      }
    },
    "complete_link": {
      "title": "You’re done!",
      "text": "Copy your download link or <a href=\"/transfer/progress\">see what's inside</a>",
      "text_copied": "The link has been copied to your clipboard",
      "text_manual_copy": "Your link is ready\nPress %{shortcut} to copy it to your clipboard",
      "document_title": "Done!"
    },
    "complete_forward": {
      "title": "Your transfer has been forwarded"
    },
    "complete_email": {
      "title": "You’re done!",
      "text": "The download email has been sent – your transfer is available for %{expires}. <a href=\"/transfer/progress\">See what's inside</a>",
      "text_no_expiry": "The download email has been sent. <a href=\"/transfer/progress\">See what's inside</a>",
      "document_title": "Sent!",
      "text_no_details": "The download email has been sent – your transfer is available for %{expires}."
    },
    "failed": {
      "title": "Hmm, something went wrong",
      "text": "So it looks like your transfer didn't work – please give it another go"
    },
    "pending": {
      "title": "We're nearly ready...",
      "subtitle": "Preparing..."
    },
    "downloading": {
      "title": "Getting your files...",
      "text": "We're just preparing your download"
    },
    "downloaded": {
      "title": "Your download has started",
      "text": "Once it's done, the files will be on your computer (often in the downloads folder).",
      "download_links": "Just be aware the links in this Board won’t show up – <a href=\"https://wetransfer.zendesk.com/hc/en-us/articles/115005062963\" rel=\"external\">read more</a>."
    },
    "expired": {
      "title": "Transfer expired",
      "text": "Sorry, this transfer has expired and is not available any more"
    },
    "password": {
      "title": "Enter password",
      "text": "You need a password to download this transfer"
    },
    "options": {
      "transfer_type": "Send as",
      "password": "Password",
      "password_placeholder": "Set password",
      "expiry": "Expires after",
      "expire_in": {
        "1w": "1 week",
        "2w": "2 weeks",
        "1m": "4 weeks",
        "never": "Never",
        "14d": "2 weeks",
        "28d": "4 weeks",
        "365d": "1 year",
        "7d": "1 week",
        "90d": "3 months"
      },
      "email": "email",
      "link": "link",
      "email_transfer": "Send email transfer",
      "transfer_link": "Get transfer link"
    },
    "buttons": {
      "transfer": "Transfer",
      "forward": "Forward",
      "new_transfer": "Send a file?",
      "cancel": "Cancel",
      "cancel_no": "No",
      "cancel_yes": "Yes",
      "copy_link": "Copy link",
      "ok": "Ok",
      "done": "Send another?",
      "retry": "Try again",
      "continue": "Continue",
      "download": "Download",
      "download_all": "Download all",
      "back_to_home": "Back to home",
      "cleanup": "Review transfers ",
      "download_all_files": "Download all files",
      "help": "Help Center",
      "payment": "Renew now",
      "complete_order": "Go to checkout",
      "download_all_experiment": "Download all as a .zip",
      "download_experiment": "Download file",
      "download_file": "Download file",
      "download_zip": "Download all as a .zip",
      "get_link": "Get Link",
      "go_to_transfer": "Go to transfer",
      "openinapp": "Save with Wetransfer app",
      "openinapp_experiment": "Save with Wetransfer app",
      "openincollectapp": "Save with Collect app",
      "get_a_link": "Get a link"
    },
    "account_expired": {
      "text": "Renew now to keep enjoying all the benefits of your Pro account, or <a href=\"#signout\">sign out</a> to use our regular service",
      "title": "Your Pro account has expired"
    },
    "invalid": {
      "text": "We couldn't find your files",
      "title": "Oops...",
      "link": "Find out more"
    },
    "outdated_browser": {
      "text": "WeTransfer supports a whole range of web browsers, but it looks like this one is too old — please update your browser",
      "title": "Your web browser is outdated"
    },
    "spam": {
      "text": "This transfer was reported as spam and has been deleted",
      "title": "Hmm..."
    },
    "storage_full": {
      "title": "Storage full",
      "text_with_limit": "You reached your %{storageLimit} limit – please delete some old transfers to continue"
    },
    "upsell_five": {
      "href": "/pro?trk=WT202006_post_transfer_inapp_message",
      "text": "Get WeTransfer Pro",
      "title": "Password-protect transfers for extra peace of mind"
    },
    "upsell_four": {
      "href": "/pro?trk=WT202006_post_transfer_inapp_message",
      "text": "Get WeTransfer Pro",
      "title": "A smarter, simpler way to manage your transfers"
    },
    "upsell_one": {
      "bubble": {
        "button": "Get Pro",
        "text": "Password-protect your transfers and choose custom expiration dates",
        "title": "Transfer upgrade?",
        "text_experiment": "You can set passwords and expiration dates on your transfers with Pro."
      },
      "href": "https://facebook.com/wetransfer",
      "text": "WeTransfer on Facebook",
      "title": "Join the WeTransfer community on Facebook"
    },
    "upsell_three": {
      "href": "/pro?trk=WT202006_post_transfer_inapp_message",
      "text": "Get WeTransfer Pro",
      "title": "Personalize your WeTransfer profile"
    },
    "upsell_two": {
      "href": "/pro?trk=WT202006_post_transfer_inapp_message",
      "text": "Get WeTransfer Pro",
      "title": "Go bigger, better, stronger, faster"
    },
    "account_inactive": {
      "text": "Complete your registration to get started with Pro",
      "title": "Your account is\nnot active yet"
    },
    "add_items": {
      "files": "Files",
      "folders": "Folders"
    },
    "appintro": {
      "button": "Get the app",
      "description": "You can preview and collect all of your content in the WeTransfer App.",
      "title": "Preview, save and organize everything"
    },
    "collectappintro": {
      "description": "You can preview and collect all of your content in the Collect App."
    },
    "complete": {
      "open_panel": "<a href=\"/transfer/progress\">See what's inside</a>"
    },
    "details": {
      "button": {
        "dismiss": "Dismiss"
      }
    },
    "download_preview": "Download file",
    "error": {
      "expired": {
        "link": "Reach out to our support team.",
        "text": "Dang, looks like your transfer has already expired.\nDoesn’t seem right?",
        "title": "Transfer expired"
      }
    },
    "item": {
      "details": {
        "folder": "Folder"
      }
    },
    "items": {
      "zero": "empty",
      "one": "%{count} item",
      "other": "%{count} items"
    },
    "mobile": {
      "button": {
        "back": "Back",
        "cancel": "Start over",
        "next": "Next"
      },
      "email": {
        "title": "Add email addresses"
      },
      "message": {
        "placeholder": "Add a message to your transfer",
        "title": "Message"
      },
      "options": {
        "email": "Send an email",
        "email-description": "Send your transfer with a simple email and we’ll let you know when it’s been downloaded.",
        "link": "Get a link",
        "link-description": "Turn your files into a link and share it however you like."
      }
    },
    "recaptcha": {
      "button": "I’m 100% human",
      "text": "We just need to check you’re not a robot (no offense)",
      "title": "You’re nearly done!"
    },
    "upsell_macapp": {
      "href": "https://itunes.apple.com/app/wetransfer/id1114922065",
      "text": "Get the Mac app",
      "title": "Send files straight from your desktop"
    },
    "upsell_survey": {
      "href": "https://we-transfer.typeform.com/to/mqUK3c",
      "text": "Help us out",
      "title": "Can we ask you something about the way you work?"
    },
    "verification-code": "Verification Code",
    "verify": {
      "button": "Start Transfer",
      "text": "Check your inbox for a verification code and pop it in below",
      "title": "You’ve got mail",
      "verification-code": "Verification code"
    },
    "account-verification-failed": {
      "body": "We’re having some trouble confirming your email. Send a new link to have another go.",
      "cta": "Send a new link?",
      "title": "Something went wrong"
    },
    "cookie-banner": {
      "button-accept": "Okay",
      "button-decline": "Nope",
      "text": "We use <a href=\"%{href}\">cookies</a> that help the website function, allow us to analyze how our users interact with it, and help us improve it. Do you also want to allow third party cookies so you get personalized advertising?"
    },
    "cookie-manager": {
      "analytical": {
        "description": "We use analytical cookies to help us understand how you use WeTransfer. They allow us to A/B test new features, ensure that everything is working as it should, and stop bots and malicious behavior like spam. These cookies may include third-party cookies which process personal information. ",
        "title": "Analytical cookies"
      },
      "clear": {
        "clear-all-cookies": "Clear all cookies",
        "description": "You can remove all your data from our cookies. For permanent anonymity requests, please contact <a href=\"mailto:support@wetransfer.com\">contact our support team.</a>",
        "title": "Clear cookies",
        "warning": "You will be signed out of WeTransfer after clearing cookies. This won’t affect transfers on your account."
      },
      "functional": {
        "description": "We use functional cookies to create a seamless experience for you on WeTransfer. They are required to use our Service.",
        "title": "Functional cookies"
      },
      "not-yet-set": "It seems like you haven’t given us your cookie preference yet. Please close this panel and set your preference, you can always change it here afterwards.",
      "save-and-reload": "Save settings",
      "tracking": {
        "description": "We use advertising cookies on our Service to help us measure the success of our commercial, editorial, and promotional efforts. Advertising cookies are not placed on pages that provide information on our brand and products. Advertising cookies allow us to record, for example, that you have clicked on a particular advertisement. If cookies placed by third parties are also placed on other domains and websites, advertisers may be able to follow your behavior across the internet, but WeTransfer cannot access or use any of this personal information that may be collected. As such, we refer you to the privacy policies of the relevant third parties.",
        "title": "Advertising cookies"
      }
    },
    "cookie-wall": {
      "button-accept": "I accept",
      "button-decline": "No thanks",
      "intro": "We use the money we make from our beautiful advertisements to help pay our bills. That’s how we can afford to provide our file-sharing service for free.",
      "text": "<p>Our website uses <a href=\"%{href}\">cookies</a> that help it to function, allow us to analyze how you interact with it, and help us to improve performance.</p>\n<p>Do you also want to allow cookies from our advertising partners so we can personalize the ads you see?</p>",
      "title": "Cookies & advertising",
      "variant-A": {
        "button-accept": "I accept",
        "button-decline": "No thanks",
        "intro": "We use the money we make from our beautiful advertisements to help pay our bills. That’s how we can afford to provide our file-sharing service for free.",
        "text": "<p>Our website uses <a href=\"%{href}\">cookies</a> that help it to function, allow us to analyze how you interact with it, and help us to improve its performance.</p>\n<p>Do you also want to allow cookies that let our advertising partners know which ads you like across different websites?</p>",
        "title": "Cookies and advertising"
      },
      "variant-B": {
        "button-accept": "Yes",
        "button-decline": "No thanks",
        "intro": "Our website uses <a href=\"%{href}\">cookies</a> to keep it working smoothly and to help us understand how you use it. We also use cookies in our advertising.",
        "text": "<p>If you would like to support our service, you can allow us to use advertising cookies that let our partners know which ads you like across different websites.</p>",
        "title": "We show you ads so we can keep WeTransfer free"
      },
      "variant-C": {
        "button-accept": "Sure thing",
        "button-decline": "No thanks",
        "intro": "From day one, WeTransfer has given away 30% of our impressions to support creatives we admire and causes we care about. We are able to do this thanks to the beautiful ads we make for brands like Apple, Saint Laurent, and Netflix.",
        "text": "<p>Our website uses <a href=\"%{href}\">cookies</a> to keep it working smoothly and to help us understand how you use it. Do you also want to allow advertising cookies (to let our partners know which ads you like across different websites) so we can show you a bit of art, and some ads?</p>",
        "title": "We show you 70% ads. 30% art."
      }
    },
    "email-verification-resend": {
      "account": {
        "error": "Oops, something went wrong",
        "error-email-exists": "Oops, looks like this email is already taken",
        "throttle-error": "Whoa, we’ve sent you too many emails now. Please wait %{throttle_time} before requesting a new code."
      },
      "back": "Back to code verification",
      "body": "Have we got this right? This is the email that you’re using on WeTransfer.",
      "email": "Email",
      "error": "Oops, something went wrong",
      "error-email-exists": "Oops, looks like this email is already taken",
      "submit": "Resend",
      "throttle-error": "Sorry, you’ve tried too many times. Please start your transfer again.",
      "throttle-error-action": "Start again",
      "throttle-error-link": "Whoa, we’ve sent you too many emails now. Please wait %{throttle_time} before requesting a new email.",
      "title": "Check your email"
    },
    "email-verification-success": {
      "body": "Now people can trust that your transfers have really been sent by you.",
      "free_signup": "Create a free account",
      "send_files": "Send files",
      "title": "Your account has been verified!",
      "upsell": "Don’t want to verify your email every time?",
      "verified_sender_tooltip": "A verified email address lets people trust that transfers have been sent by you. To change this email, update your <a href=\"%{href}\">personal details</a>."
    },
    "email-verification": {
      "account": {
        "error-expiry-time": "Uh-oh, that code is wrong or expired. Codes are only active for %{expiry_time} after they’ve been sent.",
        "error-expiry-time-action": "Get new code",
        "throttle-error": "You’ve entered a wrong or expired code too many times. Please wait %{throttle_time} before requesting a new code."
      },
      "back": "Go back",
      "body": "Just one quick check to make sure you’re really you. \n\nWe’ve sent a verification code to <strong title=\"%{account_email}\">%{account_email}</strong> (remember to check your Spam).",
      "body_link": "Just one quick check to make sure you’re really you.<br/><br/>We’ve sent a verification link to <strong title=\"%{account_email}\">%{account_email}</strong> (if you can’t find it, check your Spam).",
      "error": "Uh-oh, that code is wrong or expired",
      "error-expiry-time": "Uh-oh, that code is wrong or expired. Codes are only active for %{expiry_time} after they’ve been sent.",
      "error-expiry-time-action": "Get new code",
      "resend": "Didn't receive an email?",
      "submit": "Verify",
      "throttle-error": "Sorry, you’ve tried too many times. Please start your transfer again.",
      "throttle-error-action": "Start again",
      "title": "Verify your email",
      "verification-code": "Enter verification code"
    },
    "force-account-verification": {
      "body": "We’ll email you a link to confirm the email address you’re using on WeTransfer.",
      "cta": "Send email"
    },
    "terms_conditions-no-cookies": {
      "text": "To continue, please agree to our <a href=\"/legal/terms?from_home\" data-route-type=\"plus\">Terms of Service</a>."
    }
  },
  "languages": {
    "en": "English",
    "nl": "Nederlands"
  },
  "shortcuts": {
    "cmd_alt_l": "⌘-Alt-L",
    "cmd_j": "⌘-J",
    "cmd_c": "⌘-C",
    "cmd_shift_j": "⌘-Shift-J",
    "control_alt_l": "Ctrl-Alt-L",
    "control_j": "Ctrl-J",
    "control_c": "Ctrl-C"
  },
  "dropzone": {
    "title": "Drop it like it’s hot",
    "text": "Add files or folders by dropping them in this window"
  },
  "form": {
    "account": {
      "legend": {
        "details": "Your billing information",
        "coupon_code": "Add a discount code",
        "free_plus": "Get your free Pro account"
      },
      "label": {
        "year_label": "Annual",
        "year_sublabel": "Best value: save %{discount_rate}%!",
        "month_label": "Monthly",
        "month_sublabel": "Recurring billing",
        "email": "Email address",
        "not_required": "(optional)",
        "current_password": "Current password",
        "new_password": "New password",
        "repeat_new_password": "Confirm new password",
        "password": "Password",
        "password_confirm": "Confirm password",
        "full_name": "Full name",
        "company": "Company",
        "street_and_number": "Address",
        "city": "City",
        "zipcode": "Zip code",
        "country_code": "Country",
        "vat_number": "VAT",
        "coupon_code": "Discount code"
      },
      "description": {
        "password": "Select a password that contains at least 6 characters",
        "vat_number": "We charge companies located in the Netherlands 21% VAT. If your business is located anywhere else in the EU, please enter your company details and European tax ID to remove VAT from your bill.\n\nIf your business is located outside the EU VAT-region, we'll still need your billing information, but we won't charge VAT."
      },
      "error": {
        "email": {
          "blank": "Please enter your email address",
          "invalid": "Please enter a valid email address",
          "taken": "This email address is already in use"
        },
        "current_password": {
          "invalid": "Password not recognized",
          "blank": "Please enter your current password"
        },
        "password": {
          "blank": "Please enter your new password",
          "too_short": "Your password must contain at least 6 characters"
        },
        "password_confirm": {
          "blank": "Please confirm your new password",
          "confirm": "These passwords don't seem to match"
        },
        "full_name": {
          "blank": "Please enter your full name",
          "too_short": "Oops, your name needs at least 3 characters (sorry JT)"
        },
        "street_and_number": {
          "blank": "Please enter your address"
        },
        "city": {
          "blank": "Please enter your city"
        },
        "zipcode": {
          "blank": "Please enter your zip code"
        },
        "country_code": {
          "inclusion": "Our geography is pretty good, but we don't recognize this country – please try again",
          "blank": "Please enter your country"
        },
        "vat_number": {
          "vat_number": "Please enter a valid VAT number"
        },
        "terms_of_service": {
          "accepted": "Please accept our Terms of Service to continue"
        },
        "no_results": "Is that a country?",
        "convert": {
          "expired": "Sorry, this transfer has already expired and can't now be saved. Did you know WeTransfer Pro lets you keep transfers for as long as you want? Find out more here."
        },
        "coupon_code": {
          "coupon_code": "Please enter a valid discount code"
        }
      },
      "complete_order": "Complete your order",
      "terms_conditions": "I agree to the <a href=\"/legal/terms\" %{options}>Terms of Service</a>",
      "signup_for_plus": "Sign up for WeTransfer Pro",
      "account_cta": "Let’s go",
      "signup_for_account": "Sign up for a WeTransfer account",
      "email-verification-not-verified": "Your account is not verified. Please enter the verification code or <button type=\"button\" class=\"button button--link\">request a new code</button>.",
      "email-verification-not-verified-link": "Please verify your email address. Check the email we’ve sent you or <button type=\"button\" class=\"button button--link\">request a new one</button>.",
      "email-verification-not-verified-mobile": "Your account is not verified. Please <a class=\"form-notification__message-link\" href=\"/upload\">enter the verification code</a> sent to your email.",
      "email-verification-resend": {
        "error": "Oops, something went wrong",
        "info": "New code sent! Please check your inbox",
        "info_link": "New email sent! Please check your inbox",
        "throttle-error": "Whoa, we’ve sent you too many emails now. Please wait %{throttle_time} before requesting a new code."
      },
      "force-account-verification": {
        "message": "Please verify your email address to let us know you’re really you."
      },
      "marketing_opt_in": "I would like to receive WeTransfer news and product updates"
    },
    "profile": {
      "label": {
        "personal_url": "Profile web address",
        "profile_title": "Profile name",
        "default_recipient_email": "Email address to receive transfers",
        "wallpaper_link": "Website to link wallpapers to"
      },
      "error": {
        "subdomain_name": {
          "too_short": "We know less is more, but your profile address needs to be at least 2 characters long",
          "invalid_format": "Whoa, too weird – your profile address can only contain letters and numbers (and a dash in between)",
          "domain_name": "Sorry, someone grabbed this name already",
          "invalid": "Whoa, too weird – your profile address can only contain letters and numbers (and a dash in between)",
          "taken": "Sorry, someone grabbed this name already"
        },
        "default_recipient_email": {
          "invalid": "Please enter a valid email address"
        },
        "wallpaper_link": {
          "invalid": "Please enter a valid web address"
        }
      },
      "change_background": "Upload background",
      "delete_avatar": "Delete avatar",
      "delete_background": "Delete background",
      "description": {
        "title": "Psst, keep it to 150 characters so nothing gets cut off the page",
        "wallpaper_link": "Your wallpapers will link to this web address",
        "recipient_email_locked": "Files sent through your profile will only go to this email address"
      },
      "upload_avatar": "Upload avatar",
      "use_email_background_checkbox_label": "Use this wallpaper for all transfers sent through my profile",
      "account_email_checkbox": "Show email on profile",
      "default_recipient_email_info": "You can change this email address in your <a href=\"/account\">personal details</a>"
    },
    "fill_in_password": "Enter your password to save these changes",
    "select_all": "Select all",
    "deselect_all": "Deselect all",
    "save_changes": "Save changes",
    "submitting": "Submitting...",
    "cancel": "Cancel",
    "forward": "Forward",
    "proceed": "Continue",
    "delete": "Delete",
    "onboarding": {
      "placeholder": {
        "subdomain_name": "choose-a-good-name"
      },
      "validated": {
        "subdomain_name": "Good news – this domain is available"
      }
    },
    "confirm_leave": "Sure you want to leave this page and lose unsaved changes?",
    "contact": {
      "add_contact": "Add contact",
      "error": {
        "email": {
          "duplicate": "This email address is already in your contact list",
          "invalid": "Please enter a valid email address"
        }
      },
      "label": {
        "company": "Company",
        "email": "Email address",
        "name": "Name"
      }
    },
    "error": {
      "current_password": {
        "blank": "Please enter your current password",
        "invalid": "Password not recognized"
      },
      "email": {
        "blank": "Please enter your email address",
        "duplicate": "This email address is already in your contact list",
        "invalid": "Please enter a valid email address",
        "taken": "This email address is already in use"
      }
    },
    "leave": "Leave",
    "resetpassword": {
      "button": {
        "request_submit": "Email me",
        "reset_submit": "Save new password"
      },
      "label": {
        "confirm_new_password": "Confirm new password",
        "email": "Email address",
        "new_password": "New password"
      },
      "legend": {
        "request_description": "Locked out? We'll send you instructions to reset your password and get you back on track.",
        "request_description_success": "You've got mail! Follow the instructions we've sent you, \nor <a href=\"/contact\" rel=\"external\">contact us</a> if you don't get an email in the next ten minutes. ",
        "request_title": "Forgot your password?",
        "reset_description": "Enter a new password to get yourself back in",
        "reset_title": "Set a new password",
        "request_description_success_or_article": "If you have a WeTransfer account, we’ve sent you instructions to reset your password. Check out this <a href=\"https://wetransfer.zendesk.com/hc/en-us/articles/360033809331\" rel=\"external\">Help Center article</a> if you don’t get an email from us in the next few minutes."
      }
    },
    "signin": {
      "button": {
        "submit": "Sign in"
      },
      "label": {
        "email": "Email address",
        "password": "Password",
        "remember_me": "Remember me"
      },
      "link": {
        "forgot_password": "Forgot password?"
      },
      "title": "Log in",
      "two-factor-authentication": {
        "info": "Open the two-factor authentication app on your device to view your authentication code and verify your identity or enter one of recovery codes.",
        "otp-token-label": "Authentication code",
        "submit-text": "Verify",
        "title": "Two-factor authentication"
      }
    },
    "stay_on_page": "Stay on page",
    "close_panel": "Close",
    "facultyaccount": {
      "button": {
        "submit": "Send request"
      },
      "label": {
        "accounts": "Number of accounts needed (1 Account per student)",
        "department": "Name of the School Department(s) for which you apply",
        "email": "Email address (.edu) so we can send the coupon link",
        "email_eu": "Email address so we can send the coupon link",
        "representative": "Name and Title of the School Representative (must be staff or faculty)",
        "schoolname": "School name"
      }
    },
    "go_back": "Go back",
    "invite_team_member": {
      "already_a_member": "This person is already a member of your team",
      "already_invited": "This person has already been invited",
      "description": "Learn more about Teams <a href=\"https://intercom.help/wetransfer/plus-for-teams\" target=\"_blank\">here</a>.",
      "save_changes": "Send invite",
      "saving": "Saving...",
      "title": "Invite team member"
    },
    "join_team": {
      "submit": "Join the team",
      "title": "Yay! You're invited to join a team"
    },
    "labels": {
      "email": "Email address"
    },
    "payment_cancel": {
      "client_request": "A client requested I use WeTransfer and now I don’t need it",
      "different_tool": "I found a different tool",
      "extra_features": "I need extra features that Pro doesn’t offer",
      "not_enough_storage": "There isn’t enough storage for me",
      "not_often_large_files": "I don’t send large files often enough",
      "other": "Other",
      "other_more": "Can you tell us more?",
      "skip": "Skip and cancel subscription",
      "temp_project": "I only needed to send large files for a temporary project",
      "too_expensive": "I think Pro is too expensive"
    },
    "plan": {
      "change": {
        "month": "Monthly (%{currency}%{price})",
        "title": "Change the plan",
        "year": "Annual (%{currency}%{price})"
      },
      "change_plan": "Change payment plan",
      "month": {
        "copy": "Recurring billing",
        "label": "Monthly",
        "label-payment": "Monthly payment",
        "sub-label": "One bill, every month",
        "title": "WeTransfer Pro: Monthly payment"
      },
      "title": "Give your ideas the premium treatment they deserve",
      "year": {
        "discount": "Save %{rate}% (ooh yeah)",
        "label-payment": "Yearly payment",
        "sub-label": "That’s a 17% saving. Zing",
        "title": "WeTransfer Pro: Yearly payment"
      },
      "your_order": "Your order"
    },
    "save_and_continue": "Save and continue",
    "studentaccount": {
      "button": {
        "submit": "Send request"
      },
      "label": {
        "email": "Fill in your student email (.edu)",
        "email_eu": "Fill in your student email"
      }
    },
    "upgrade": {
      "better_service": "## A better service\n* Send up to %{file_size_limit} at a time\n* Store up to %{storage_limit}\n* Password protect your files",
      "better_service_1": "A better service",
      "better_service_2": "Send up to %{file_size_limit} at a time",
      "better_service_3": "Store up to %{storage_limit}",
      "customise": "## Your own look and feel\n* Personalize your profile\n* Add background video or images\n* Customize your emails"
    },
    "fill_in_password_two_factor_authentication": "Enter your password to continue",
    "login": {
      "button": {
        "submit": "Submit"
      },
      "two-factor-authentication": {
        "text": "Enter the verification code from Google Authenticator (or your chosen authenticator app). Don’t have your phone handy? You can use one of your recovery codes instead.",
        "title": "Two-factor authentication",
        "verification_code": "Verification code",
        "verify": "Verify"
      }
    },
    "submit": {
      "two-factor-authentication": "Submit"
    }
  },
  "external_links": {
    "android_app": "https://we.tl/android",
    "facebook": "https://www.facebook.com/wetransfer",
    "homerun": "https://wetransfer.homerun.co",
    "instagram": "https://www.instagram.com/WeTransfer/",
    "ios_app": "https://we.tl/iosapp",
    "twitter": "https://twitter.com/WeTransfer",
    "chrome_extension": "https://we.tl/moment4chrome",
    "cli": "https://we.tl/wtclient",
    "prco": "https://wetransfer.pr.co",
    "youtube": "https://www.youtube.com/WeTransfer"
  },
  "notification": {
    "update_account": "Your account has been updated",
    "update_password": "Your password has been updated",
    "update_subscription": "Your payment plan has been updated",
    "update_profile_success": "Your profile has been updated ",
    "link_copied": "This link has been copied to your clipboard",
    "copy_link": "This link has been copied to your clipboard",
    "copy_link_manual": "Link selected – copy it using %{shortcut}",
    "delete_transfer_success": "Transfer has been deleted",
    "delete_transfers_success": "Transfers have been deleted",
    "update_expiry_success": "The expiration date has been updated",
    "onboarding_success": "This way for your transfer overview, contacts, profile settings and other bits and pieces",
    "add_contact_success": "This contact has been added",
    "edit_contact_success": "This contact has been updated",
    "remove_contact_success": "This contact has been deleted",
    "already_signed_in": "You are now signed in",
    "android_app_desc": "Save and share with the WeTransfer app",
    "android_app_title": "WeTransfer for Android",
    "cancel_subscription_success": "Sorry to see you go - your subscription has been cancelled.",
    "cancelled_team_invitation": "You've cancelled the invite sent to %{email}",
    "changed_team_member_role": "You've changed %{fullName}'s role",
    "collect_app_banner_desc": "Preview, save and manage files from the Collect app",
    "contact_added_confirmation": "Contact was added to your transfer",
    "contact_recipient_locked_text": "This page is for the owner to receive files. Sending to somebody else?",
    "forward_ready": "Your transfer is ready to forward",
    "invited_to_team": "Your invite has been sent to %{email}",
    "ios_app_desc": "Save and share with the WeTransfer app",
    "ios_app_desc_experiment": "Preview, save and manage files from the WeTransfer app",
    "ios_app_download": "Download WeTransfer app",
    "ios_app_download_experiment": "Install",
    "ios_app_open": "Open in app",
    "ios_app_open_experiment": "Open",
    "ios_app_text": "WeTransfer for iOS\nSave and share with the WeTransfer app",
    "ios_app_title": "WeTransfer for iOS",
    "ios_app_title_experiment": "Save it in the app",
    "mobile_app_banner_desc": "Preview, save and manage files from the app",
    "mobile_app_banner_download": "Install",
    "mobile_app_banner_open": "Open",
    "mobile_app_banner_title": "Save it in the app",
    "reactivate_subscription_success": "Welcome back! Your account has been reactivated. ",
    "received_transfers": {
      "confirmation_email": {
        "cta": "Got it",
        "general_error": "Something went wrong!",
        "sent": "Email sent! Check your inbox."
      }
    },
    "refresh_transfer_upload_lost": "Are you sure you want to cancel the current upload?",
    "removed_team_member": "%{fullName} has been taken off this team",
    "update_payment_success": "Your payment details were successfully updated. Zing.",
    "update_user": "Your details have been updated",
    "canceled_transfer_success": "Your transfer upload has been canceled",
    "download_started": "Your download has started. Once it's done, the files will be on your computer (often in the downloads folder).",
    "logged_out": "Looks like you’ve been logged out from another browser. Please log in again.",
    "transfer_renamed": "Your transfer has been renamed"
  },
  "alert": {
    "confirm_cancel_upload_image": "Are you sure you want to cancel the current upload? ",
    "cancel_recipient_locked": "Cancel",
    "cancel_refresh_transfer_upload_lost": "No",
    "confirm_refresh_transfer_upload_lost": "Yes",
    "go_to_transfer": "Go to transfer",
    "redirect_recipient_locked": "Yes",
    "stay": "Stay"
  },
  "force_update": "Exciting things ahead! Please <a href=\"/\" onClick='javascript:window.location.reload();'>refresh your browser</a> to make sure you are using the latest version of WeTransfer.",
  "panel": {
    "design": "You’ve probably noticed we’ve made a few changes round here! Many of them are things you told us you wanted to see. So enjoy exploring the new and (dare we say) improved site, and please send us any feedback here.",
    "loading_error": "Hmm, it looks like this page is having problems loading at the moment.\nWe'll keep trying, or <a href=\"%{path}\">try to refresh it</a> yourself.",
    "redesign_notice": "You’ve probably noticed we’ve <a href=\"/about/redesign\">made a few changes</a> round here! Many of them are things you told us you wanted to see. So enjoy exploring the new and (dare we say) improved site, and please <a href=\"/contact\" rel=\"external\">send us any feedback here<a/>.",
    "return_to": "back to %{pageName}",
    "warning": {
      "account_inactive_action": "Complete payment",
      "account_inactive_subtitle": "Complete your registration to get started with Pro",
      "account_inactive_title": "Your account is not active yet!",
      "account_subscription_action": "Renew now",
      "account_subscription_expired": "Your Pro account has expired",
      "account_subscription_subtitle": "Renew now to keep your transfers, personal wallpapers and web address. Please note otherwise they will be deleted soon!",
      "account_expired_action": "Renew now",
      "account_expired_subtitle": "Renew now to keep enjoying all the benefits of your Pro account",
      "account_expired_title": "Your Pro account has expired",
      "expired_transfer_subtitle": "The files are no longer available. You can remove the info from your transfer overview <a>here</a>.",
      "expired_transfer_title": "This transfer has expired",
      "account_email_verify_logged_out": "Please log in to verify your email",
      "email_unverified_mobile_cta": "Ready to verify",
      "email_unverified_text": "We’ve sent a verification code to %{email}. <a href='%{href}'>Not you?</a>",
      "email_unverified_text_link": "We’ve sent an email to %{email}. <a href='%{href}'>Not you?</a>",
      "email_unverified_title": "Please verify your email address",
      "force-account-verification": {
        "body": "We’ll email you a link to make sure you’re really you."
      },
      "receiving-email": "Heads up! We have replaced %{receiving_email} in your profile. This means that new transfers will only appear in your transfer overview if they are sent to %{account_email}. To change this, you can update your <a href=\"/account\">personal details</a> anytime."
    },
    "close": "Close panel",
    "cookie": {
      "accept": "Okay",
      "text": "We use cookies. Read <a href=\"/legal/terms\">the legal stuff</a> (no recipes included)."
    },
    "footer": {
      "facebook": "Facebook",
      "instagram": "Instagram",
      "jobs": "Jobs",
      "press": "Press",
      "terms": "Terms",
      "twitter": "Twitter",
      "youtube": "YouTube"
    }
  },
  "user": {
    "already_logged_in": "You're already signed in – are you sure you want to reset your password?",
    "roles": {
      "admin": "admin",
      "owner": "owner",
      "user": "user"
    },
    "sign_out_and_reset": "Sign out and reset password"
  },
  "click_here": "Click here",
  "cookiebox": {
    "notice": "<bold>You are currently signed in</bold>, you will be signed out after clearing your cookies. Past transfers on your account won’t be affected."
  },
  "notice": {
    "general_issues": "Things not working as they should be? We know it’s frustrating, but hang in there and we’ll get things back up and running <a target=\"_blank\" href=%{link}>as soon as we can</a>",
    "transfer_issues": "Having trouble with your transfer? We know it’s frustrating, but hang in there and we’ll get things back up and running <a target=\"_blank\" href=%{link}>as soon as we can</a>",
    "projects_promo": {
      "cta": "Try our new feature!",
      "emoji": "✨",
      "hook": "Working on a project?",
      "output": "%{hook} %{cta} %{emoji}"
    },
    "verification": "Hey, we need you to <a href=\"/account\">confirm your email</a>"
  },
  "transfer_link": {
    "buttons": {
      "copied": "Link copied",
      "copy": "Copy link",
      "copy_again": "Copy again"
    },
    "labels": {
      "share": "Share this transfer"
    }
  },
  "verify": {
    "activation-code": "Verification Code (6 digits)",
    "email_send": "Psst! We've sent an email to %{email}",
    "opt-in": {
      "confirm-desc": "Next time you send a transfer using %{email} we’ll send you a code to check it’s you.",
      "confirm-title": "Your email is now verified!",
      "intro": "Register your email address. Every time a transfer is sent from that address, it’ll be sent a confirmation code. Get extra peace of mind by confirming it’s you. Get set up in two simple steps:",
      "opt-in-button": "Verify",
      "opt-out-message": "Want to stop using email address verification?",
      "step-one-desc": "Enter the email address you’d like to register.",
      "step-two-desc": "Check your inbox for a verification code and enter it below. ",
      "title": "Verify your email address"
    },
    "opt-out": {
      "confirm-desc": "We turned off email verification for %{email}. You won’t receive any verification emails again when sending transfers using this email address.",
      "confirm-title": "All done!",
      "intro": "By completing these two steps you’ll no longer receive a confirmation code with every transfer.",
      "opt-in-message": "Want to opt-in for email address verification?",
      "opt-out-button": "Turn off",
      "step-one-desc": "Enter your registered email address.",
      "step-two-desc": "Check your inbox for one last code and enter it below.",
      "title": "Stop using email verification"
    },
    "send": "Submit",
    "step-one": "Step 1",
    "step-two": "Step 2",
    "your-email": "Your email address"
  },
  "welcome": {
    "background": {
      "feature_1": "We display ads and works from the creative community on the background"
    },
    "plan": {
      "free": {
        "feature_1": "Simple file-sharing",
        "feature_2": "No registration",
        "feature_3": "It's free"
      }
    },
    "title": "Welcome to"
  },
  "account": {
    "verify-info": "Why we’re asking you to confirm your email"
  },
  "feature_banner": {
    "pro": "WeTransfer Plus is now WeTransfer Pro with 1 TB of storage — that’s 10x more. <a href=\"/transfers\">Check it out.</a>"
  },
  "time": {
    "days": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "months": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    },
    "remaining": {
      "minutes": {
        "zero": "Under a minute remaining",
        "one": "About 1 minute remaining",
        "other": "About %{count} minutes remaining"
      },
      "hours": {
        "one": "About an hour remaining",
        "other": "About %{count} hours remaining"
      }
    }
  },
  "download": {
    "shortcut": "Press %{command} to see the<br />download progress",
    "shortcuts": {
      "control_j": "Ctrl-J",
      "control_alt_l": "Ctrl-Alt-L",
      "cmd_shift_j": "&#8984;-Shift-J",
      "cmd_j": "&#8984;-J",
      "cmd_alt_l": "&#8984;-Alt-L"
    }
  },
  "upload": {
    "title": "Send up to %{size}",
    "progress": {
      "busy": "Transferring..."
    },
    "buttons": {
      "add": "Add files",
      "transfer": "Transfer",
      "forward": "Forward"
    },
    "forward": {
      "done": "Forward complete"
    },
    "friend_email": {
      "title": "Friend's email",
      "more": "Add more friends"
    },
    "your_email": {
      "title": "Your email"
    },
    "message": {
      "title": "Message"
    },
    "done": {
      "title": "Transfer complete",
      "link": "Copy your download link:",
      "copied": {
        "title": "Copied!",
        "text": "The download link has been copied."
      }
    },
    "more_html": "Add more files<span>(%{size} left)</span>",
    "too_many_recipients": "Seems like you've entered too many email addresses. Remember: there's room for up to %{count} people at a time.",
    "completed": "%{size} of %{total} completed",
    "addresses": {
      "one": "%{count} address",
      "other": "%{count} addresses",
      "remove": "Do you want to remove %{address} from your previous recipients?"
    },
    "ads": {
      "plus": {
        "title": "Get more out<br />of WeTransfer<br />with Pro",
        "text": "<ul><li>Supersized uploads</li><li>Personalised transfers with your own backgrounds</li><li>Password protected transfers</li><li>Long term storage</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>"
      },
      "plus2": {
        "title": "Impress<br />with your<br />own custom download page",
        "text": "<p>Use your own backgrounds and custom WeTransfer URL (yourname.wetransfer.com)<br />to impress your recipients.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>"
      },
      "plus3": {
        "title": "Manage<br />your transfers smarter",
        "text": "<p>This transfer is deleted after a week, but with WeTransfer Pro you can store indefinitely, resend and delete instantly, without having to upload again.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>"
      },
      "plus4": {
        "title": "Get extra protection<br />for your files",
        "text": "<p>With WeTransfer Pro, you can protect your important and confidential files with a password.</p><p>That way they will never fall into the wrong hands.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>"
      },
      "facebook": {
        "title": "Join the<br />WeTransfer<br />community<br />on Facebook",
        "text": "<p>Get the latest news, win prizes, discover new artists, read interviews and much more.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Find out more</a></p>"
      },
      "flipflops": {
        "title": "Free flipflops by WeTransfer",
        "text": "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>"
      }
    },
    "errors": {
      "only_email": "Sorry, only email is supported when resending a transfer.",
      "connect_twitter": "Your Twitter account is not yet connected to WeTransfer.",
      "connect_facebook": "Your Facebook account is not yet connected to WeTransfer.",
      "transferproblems": {
        "title": "Transfer problem",
        "text": "Hate to break it to you, but something went wrong with the transfer."
      },
      "limitreached": {
        "title": "Storage Limit",
        "text": "You reached your 1 TB limit. Delete some old transfers to send new files"
      },
      "blocked": {
        "title": "Transfer problem",
        "text": "Computer says no. Sorry, but you have been blocked from WeTransfer."
      },
      "upload_error": {
        "title": "Transfer problem",
        "text": "Hate to break it to you, but something went wrong with the transfer."
      },
      "unavailable": {
        "title": "Transfer error",
        "text": "Sorry, this transfer has already been deleted so it cannot be forwarded."
      },
      "startswithdot": {
        "title": "Oops",
        "text": "One (or more) of your files has a name that starts with a full stop. That's not going to work. Please rename the file(s), and try adding them again."
      },
      "startswithspace": {
        "title": "Oops",
        "text": "One (or more) of your files has a name that starts with a space. That's not going to work. Please rename the file(s), and try adding them again."
      },
      "containsreturn": {
        "title": "Oops",
        "text": "One (or more) of your files has a name that contains a return. We don't know quite how you've done that, but it's not going to work. Please rename the file(s), and try adding them again."
      },
      "alreadyinlist": {
        "title": "Yikes",
        "text": "Turns out one of your files had the same name as another file that you've already selected. Change it up a little!"
      },
      "transfertoobig": {
        "title": "Uh-oh",
        "text": "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time."
      },
      "filetoobig": {
        "title": "Uh-oh",
        "text": "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time."
      },
      "zerobytes": {
        "title": "Whoops",
        "text": "One (or more) of your files is empty or could not be read."
      },
      "ioerror": {
        "title": "Fail",
        "text": "One (or more) of your files could not be read or is larger than %{upload_limit}GB. That's not going to fly."
      },
      "filenametoolong": {
        "title": "Yikes",
        "text": "One (or more) of your files has a filename that is longer than 250 characters. We can't accept filenames longer than this, so please rename it."
      },
      "nofolders": {
        "title": "Uh-oh",
        "text": "Sorry, uploading folders doesn't work yet. Try zipping it first."
      },
      "nofiles": {
        "title": "Oops",
        "text": "You haven't actually added any files yet."
      },
      "norecipients": {
        "title": "Doh!",
        "text": "Looks like you forgot to enter any email addresses to send to."
      },
      "toomanyrecipients": {
        "title": "Yikes",
        "text": "Too many recipients."
      },
      "bigmessage": {
        "title": "Oops",
        "text": "Your message is longer than a novel. Please make it shorter."
      },
      "nosender": {
        "title": "Seriously?",
        "text": "You forgot to enter your own email address. How could you?"
      },
      "senderemailinvalidformat": {
        "title": "Uh-oh",
        "text": "Your email address appears to be incorrect. Mind your spelling!"
      },
      "probablynotcopied": {
        "title": "Oops",
        "text": "It looks like you haven't copied the link."
      },
      "recipientemailinvalidformat": {
        "title": "Oops",
        "text": "You entered one of your friend's email addresses incorrectly."
      },
      "requiresdefaultrecipient": {
        "title": "Uh-oh",
        "text": "Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again."
      },
      "containsbackslash": {
        "title": "Yikes",
        "text": "One (or more) of your files has a filename that contains a backslash. We can't accept this, so please rename the files so they don't contain the backslash."
      }
    },
    "tips": {
      "maxfilesize_tip": {
        "title": "Tip",
        "text": "You can send up to 2GB per transfer. And what's even better: you can transfer as often as you like."
      },
      "maxfilesize_oldbrowser_tip": {
        "title": "Important",
        "text": "Your Pro account can send up to 20 GB per transfer, but your browser is preventing this. <a href='/questions/33'>Click here for more information</a>"
      },
      "recipients_tip": {
        "title": "Tip",
        "text": "You can enter up to %{email_limit} email addresses to send to. If you just want a download link, click on the share button below."
      },
      "default_recipient": {
        "title": "Tip",
        "text": "To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you."
      },
      "sender_tip": {
        "title": "Tip",
        "text": "Pop your own email address in here so we can contact you when the files have been downloaded."
      },
      "expire_tip": {
        "title": "Tip",
        "text": "You can now change the expiry date of your Pro transfers."
      },
      "message_tip": {
        "title": "Tip",
        "text": "Want to send your friends a message along with the files? Here's your chance - but you don’t have to."
      },
      "share_tip": {
        "title": "Tip",
        "text": "Change the way you share your files. Send them by email or grab a download link.",
        "text_plus": "Change the way you share your files. Send them by email, Twitter, Facebook, or grab a download link."
      },
      "download": {
        "title": "",
        "chrome": "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The download progress should be visible at the bottom of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out how to change this behaviour here</a>.",
        "firefox": "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in your browser's Download window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        "safari": "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in the top right corner of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        "old_explorer": "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. You may also see a security alert at the top of the browser window. <a href='/questions/24' target='_blank'>Find out more</a>.",
        "explorer": "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible at the bottom of your browser window (you may need to click on Save first), and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        "settings": "You can change your default download location in your browser settings."
      }
    }
  },
  "warnings": {
    "unsaved_changed": "You have made changes to your Channel. Are you sure you want to leave this page without saving?",
    "forwarding": "Forwarding this transfer will clear the form, are you sure?",
    "is_busy": "Sorry, we can't do this right now"
  },
  "mobile_app": {
    "remember_choice": "Don't show this message again",
    "uploader": {
      "description": "Our site is not optimised for mobile right now. But we do have a shiny mobile app.",
      "app_name": "WeTransfer",
      "download": "Download the App",
      "continue": "Continue to WeTransfer.com"
    },
    "downloader": {
      "title": "Your files are ready for download!",
      "description_ios": "We've bundled your files in a zip file. You will need an app to extract and view the files. We think \"<a href=\"https://itunes.apple.com/us/app/winzip/id500637987?mt=8\">Winzip</a>\" is a pretty good app for that.",
      "description_android": "We've bundled your files in a zip file. You will need an app to extract and view the files. We think \"<a href=\"https://play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en\">ES File Explorer</a>\" is a pretty good app for that.",
      "continue": "Understood"
    }
  }
};
